/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-line no-nested-ternary

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Box, Table, TableBody, TableCell, InputAdornment, Dialog, DialogTitle, DialogContent, Alert, Snackbar, TableContainer, TableHead, TableRow, Paper, Pagination, Container, Typography, Tab, Tabs, Card, CardContent, Switch, FormControlLabel, Grid, useTheme, useMediaQuery, Chip, TextField, Select, MenuItem, FormHelperText, FormControl, Button, LinearProgress, CircularProgress } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CloseIcon from "@mui/icons-material/Close";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { FaceFrownIcon, FaceSmileIcon } from '@heroicons/react/24/solid'
import { BellIcon, CreditCardIcon, UserIcon, KeyIcon, PencilSquareIcon, AcademicCapIcon, CloudArrowDownIcon,  CheckCircleIcon } from '@heroicons/react/24/outline'
import { LockKeyhole, ShieldCheck, AlertTriangle,  ClipboardList, MapPin, Monitor, Smartphone, Settings } from 'lucide-react'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { isValid } from "date-fns";
import moment from "moment";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { UAParser } from 'ua-parser-js';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import es from 'react-phone-input-2/lang/es.json'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PublicIcon from '@mui/icons-material/Public';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import * as Yup from 'yup';
import noSubscriptions from '../../assets/Images/noSubscriptions.png'
import shieldCheck from '../../assets/Images/shieldCheck.svg'
import DialogModal from '../../components/modal/DialogModal';
import loginServices from '../../services/loginServices';
import identifyPosthogUser from '../../utils/posthogIdentify';
import preSignedServices from '../../services/preSignedServices';
import Page from '../../components/Page';
import adminServices from '../../services/adminServices';
import SnackBar from '../../components/snackbar/snackbar';
import ResetPasswordModal from './ResetPasswordModal';
import { loginSuccess, ComingFrom, ComingFromSub } from '../../store/reducer';
import PhoneNumber from '../../components/PhoneNumber/Index';
import '../../components/PhoneNumber/styles.css';
import ResponsiveDrawer from '../users/course/profilesidebar';
import WorkspaceSetup from '../login/loginonboard'
import { getCategoryDetails } from '../../Redux/Action';
import Footer from '../../components/Footer'

const Account = () => {
  const [searchParams] = useSearchParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const tabParam = searchParams.get("tab");
  const [tabValue, setTabValue] = useState(0)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const userInfo = useSelector((state) => state.userInfo);
  // Google-only signups have no password_sha256 — only treat it as "no
  // password" when the backend explicitly says so (hasPassword === false),
  // so older cached userInfo without this field still behaves like before.
  const hasPassword = userInfo?.hasPassword !== false;
  const [userData, setUserData] = useState('');
  const fileInputRef = useRef(null);


  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam !== null) {
      setTabValue(Number(tabParam));
    }
  }, [searchParams]);

  const firstName = userData.first_name;
  const lastName = userData.last_name;
  const initials = `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''}`.toUpperCase();

  const { id } = userInfo
  const [editField, setEditField] = useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isClickedButton, setIsClickedButton] = useState(false);
  const [countries, setCountries] = useState([]);
  const allcourseDetails = useSelector((state) => state);
  const onboardinddetails = useSelector((state) => state?.onboardinfo);
  const navigate = useNavigate()
  const [activeStep, setActiveStep] = React.useState(0);
  const [detail, setDetail] = useState('Personal');
  const [alldata, setAlldata] = React.useState('');
  const [phone, setPhone] = useState('');  



  const [exportRequests, setExportRequests] = useState([]);
  const [loadingExports, setLoadingExports] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");

  const [genderDetails, setGenderDetails] = React.useState([]);
  const [roleDetails, setRoleDetails] = React.useState([]);
  const [workDetails, setWorkDetails] = React.useState([]);
  const [educationDetails, setEducationDetails] = React.useState([]);
  const [aboutDetails, setAboutDetails] = React.useState([]);
  const [jobDetails, setJobDetails] = React.useState([]);
  const [categoryDetails, setCategoryDetails] = React.useState([]);
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [snackbarType, setSnackbarType] = useState(""); // "success" | "error"
  const [carrierDetails, setCarrierDetails] = React.useState([]);
  const [showOthersInput, setShowOthersInput] = useState(false);
  const [newTag, setNewTag] = useState('');
  const [selectedDate, setSelectedDate] = useState('');  
  
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [progress, setProgress] = useState(0);
  const [openResetModel, setOpenResetModel] = useState(false);
  const closeResetModel = () => setOpenResetModel(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [UpdateLoading, setUpdateLoading] = useState(false);
  const [error, setError] = useState({ firstNameError: '', lastNameError: '', photoError: '' })

  const [showActivityLog, setShowActivityLog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState('');
  const [deleteConfirmText, setDeleteConfirmText] = useState('')
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [activityLog, setActivityLog] = useState([]);
  const [loadingActivity, setLoadingActivity] = useState(false);
  const [billingPlans, setBillingPlans] = useState(false);

  const [originalInitial, setOriginalInitial] = useState(null);
  const [newPasswordError, setNewPasswordError] = useState('');
  const [oldPasswordError, setOldPasswordError] = useState('');
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState('');
  const [privacyLoading, setPrivacyLoading] = useState(false);
  const [lastExportRequest, setLastExportRequest] = useState(null);
  const [isExportLocked, setIsExportLocked] = useState(false);
  const [unlockDate, setUnlockDate] = useState(null);


  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  let paginatedData = activityLog?.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  paginatedData = paginatedData.map(item => {
    const parts = item.device.split(" - ");

    let deviceType = "desktop";
    const lower = item.device.toLowerCase();

    if (lower.includes("mobile")) deviceType = "mobile";
    const os = parts[0]?.replace(/\(.*?\)/g, "").trim() || "";
    const browser = parts[1]?.replace(/\(.*?\)/g, "").trim() || "";

    return {
      ...item,
      deviceLabel: `${os} – ${browser}`,
      deviceType
    };
  });


  const defaultNotificationPreferences = {
    newCourseLaunch: false,
    promotionalOffers: false,
    courseAnnouncements: false,
    newAssessmentLaunch: false,
    discountsAndOffers: false,
    gradesAndCompletion: false,
  };

  const ACTION_LABELS = {
    DATA_EXPORT_REQUEST: "DATA EXPORT REQUEST",
    LOGIN: "LOGIN ATTEMPT",
    LOGIN_FAILED: "LOGIN ATTEMPT",
    FORGOT_PASSWORD: "FORGOT PASSWORD",
    PASSWORD_UPDATED: "PASSWORD UPDATE",
    PASSWORD_UPDATE_FAILED: "PASSWORD UPDATE",
    ACCOUNT_DELETION_REQUESTED: "ACCOUNT DELETION REQUEST",
    PROFILE_UPDATED: "PROFILE UPDATE"
  };
  const [originalPreferences, setOriginalPreferences] = useState({});
  const [notificationPreferences, setNotificationPreferences] = useState(defaultNotificationPreferences);
  const [loadingNotificationPrefs, setLoadingNotificationPrefs] = useState(false);
  const [savingNotificationPrefs, setSavingNotificationPrefs] = useState(false);
  const [isEditingPrefs, setIsEditingPrefs] = useState(false);



const formatDateLocal = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (!isValid(date)) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  useEffect(() => {
    if (dialogType === 'changePassword') {
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');

      setOldPasswordError('');
      setNewPasswordError('');
      setConfirmNewPasswordError('');
    }
    if (dialogType === 'deleteAccount') {
      setDeleteConfirmText('');
    }
  }, [dialogType]);


  const fetchUserActivityLogs = async () => {
    try {
      setLoadingActivity(true);
      const res = await adminServices.getUserActivityLog(userInfo?.id);
      setActivityLog(res.data);
    } catch (error) {
      console.log("Failed to load activity logs", error);
    }
    setLoadingActivity(false);
  };

  const getLatestWithdrawDate = () => {
    const logs = activityLog?.filter(
      log => log?.withdraw_date !== null
    );

    if (!logs?.length) return null;

    const latest = logs?.sort(
      (a, b) => new Date(b.withdraw_date) - new Date(a.withdraw_date)
    )[0];

    return latest?.withdraw_date;
  };

  const latestWithdrawDate = getLatestWithdrawDate();

  let isDeletionLocked = false;

  if (latestWithdrawDate) {
    const withdraw = new Date(latestWithdrawDate);
    const unlock = new Date(withdraw);
    unlock?.setDate(unlock.getDate() + 13);
    isDeletionLocked = new Date() < unlock;
  }

  function mapActionLabel(action) {
    return ACTION_LABELS[action] || action;
  }

  const handleToggleLog = () => {
    setShowActivityLog(prev => !prev)
  }

  const handleChangePhone = (e) => {
    setPhone(e)
  }

  const handleDateChange = (newValue) => {    
    setSelectedDate(newValue);
  };

  const fetchLatestExportRequest = async () => {
    try {
      const res = await adminServices.getDataExportRequest();
      if (res?.ok && res?.data && res?.data?.data) {
        const exportData = res?.data?.data;
        setLastExportRequest(exportData);
        if (exportData?.createdDate) {
          const createdDate = new Date(exportData?.createdDate);
          const unlockDate = new Date(createdDate);
          unlockDate.setMonth(unlockDate?.getMonth() + 3);
          setUnlockDate(unlockDate);
          setIsExportLocked(new Date() < unlockDate);
        }
      }

    } catch (err) {
      console.log("Failed to load data export request", err);
    }
  };

  const dialogTitles = {
    requestData: "Request Data",
    deleteAccount: "Request Account Deletion",
    removePayment: "Remove Payment Method",
    addPayment: "Add Payment Method",
    // joinWaitlist: "WhatsApp Join the waitlist",
    changePassword: "Change Password"
  };

  const logUserActivity = async (actionName, status) => {
    try {
      const ua = JSON.parse(localStorage.getItem("ua"))
      const payload = {
        userId: userInfo?.id,
        action: actionName,
        browser: ua?.browser?.name,
        browserVersion: ua?.browser?.version,
        os: ua?.os?.name,
        osVersion: ua?.os?.version,
        deviceVendor: ua?.device?.vendor || "Unknown",
        deviceModel: ua?.device?.model || "Unknown",
        deviceType: ua?.device?.type || "desktop",
        ip: localStorage.getItem("ip"),
        status,
        locationPermission: localStorage.getItem("locationPermission"),
        location: localStorage.getItem("location")
      };
      await adminServices.captureUserActivity(payload);
    } catch (error) {
      console.error(" Failed to log user activity", error);
    }
  };
  const handleNavigation = () => {
    if (userInfo?.role === 'AUTH_USER') {
      navigate('/app/course');
    }
    else {
      dispatch(ComingFrom('Dashboard'));
      dispatch(ComingFromSub(''));
      navigate('/auth/subscribe');
    }
  }
  const handleNavigationAssessments = () => {
    if (userInfo?.role === 'AUTH_USER') {
      navigate('/app/course');
    }
    else {
      dispatch(ComingFrom('Assessments'));
      dispatch(ComingFromSub(''));
      navigate('/auth/subscribe', { state: { comingFrom: 'profile' } });

    }
  }
  const handleNavigationCourses = () => {
    if (userInfo?.role === 'AUTH_USER') {
      navigate('/app/course');
    }
    else {
      dispatch(ComingFrom('Courses'));
      dispatch(ComingFromSub('AllCourses'));
      navigate('/auth/subscribe');
    }
  }

  const handleTabChange = (event, newValue) => {
    const tabValue = searchParams.get("tab");
    if (tabValue === 1 || tabValue === "1") {
      navigate('/auth/account')
    }

    setTabValue(newValue);
    setEditField(false);
    setShowActivityLog(false);
    setIsEditingPrefs(false);
    if (newValue === 3) {
      setPage(1);
    }
  };

  const { t } = useTranslation('translation');

  useEffect(() => {
    if (dialogType === 'changePassword') {
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  }, [dialogType]);

  const handleUpdatePassword = async () => {
    const parser = new UAParser();
    const ua = parser.getResult();
    const ipRes = await fetch("https://api.ipify.org?format=json");
    const ip = (await ipRes.json()).ip;
    setOldPasswordError("");
    setNewPasswordError("");
    setConfirmNewPasswordError("");

    let hasError = false;

    if (!currentPassword && !newPassword && !confirmPassword) {
      setOldPasswordError("*Current password field is required");
      setNewPasswordError("*New password field is required");
      setConfirmNewPasswordError("*Confirm new password field is required");
      return;
    }

    if (!currentPassword) {
      setOldPasswordError("Your current password is required");
      hasError = true;
    }

    if (!newPassword) {
      setNewPasswordError("New password is required");
      hasError = true;
    } else if (newPassword.length < 4) {
      setNewPasswordError("New Password should be above 4 characters");
      hasError = true;
    }

    if (!confirmPassword) {
      setConfirmNewPasswordError("Please Enter you new password");
      hasError = true;

      if (newPassword && !confirmPassword) {
        setConfirmNewPasswordError("Please Enter you new password");
      }
    } else if (newPassword !== confirmPassword) {
      setConfirmNewPasswordError("*Both passwords should match. Please enter again!");
      hasError = true;
    }

    if (!newPassword && confirmPassword) {
      setNewPasswordError("New password is required");
      setConfirmNewPasswordError("Both passwords should match. Please enter again!");
      hasError = true;
    }

    if (hasError) return;

    try {
      const passwordData = {
        userId: userInfo?.id,
        currentPassword,
        newPassword
      };

      const response = await loginServices.updatePasswordLoggedIn(passwordData);

      if (response.ok) {
        setSnackbarType("success");
        setSnackbarTitle("Password updated successfully!");
        setSnackbar(true);
        handleDialogClose("changePassword");

        logUserActivity("PASSWORD_UPDATED", "Success");

        localStorage.removeItem("persist:root");
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");

        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "tokenExpireTime=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        setTimeout(() => {
          window.location.href = "/login";
        }, 1200);

      } else {

        logUserActivity("PASSWORD_UPDATE_FAILED", "Failed");
        if (response.data?.message?.toLowerCase().includes("current")) {
          setOldPasswordError("Your current password doesn’t match. Please try again!");
        } else {
          setNewPasswordError(response.data?.message || "Failed to update password");
        }
      }

    } catch (error) {
      console.log(error);
      setSnackbarType("error");
      setSnackbarTitle("Something went wrong");
      setSnackbar(true);
    }
  };

  const handleRequestData = async () => {
    if (loadingRequest) return;
    setLoadingRequest(true);

    try {
      const response = await adminServices.requestData();

      if (response.ok) {
        await logUserActivity("DATA_EXPORT_REQUEST");
        await fetchUserActivityLogs();
        await fetchLatestExportRequest();
        setSnackbarType("success");
        setSnackbarTitle("Your data request has been submitted.");
        setSnackbar(true);
        setPrivacyLoading(true);
        setTimeout(() => {
          setPrivacyLoading(false);
        }, 2000);
        handleDialogClose();
      } else {
        setSnackbarType("error");
        setSnackbarTitle(response.data?.message || "Request failed");
        setSnackbar(true);
      }
    } catch (error) {
      console.log(error);
      setSnackbarType("error");
      setSnackbarTitle("Something went wrong");
      setSnackbar(true);
    }

    setLoadingRequest(false);
  };

  const handleRequestDeletion = async (confirmText) => {
    if (confirmText !== "DELETE") {
      setSnackbarType("error");
      setSnackbarTitle("Please type DELETE to confirm");
      setSnackbar(true);
      return;
    }
    if (loadingRequest) return;
    setLoadingRequest(true);

    try {
      const response = await adminServices.setUserHardDeleteStatus(userInfo?.id);

      if (response.ok) {
        const response1 = await logUserActivity("ACCOUNT_DELETION_REQUESTED", 'Processing');
        // if (response1 === true || response1?.message === "Activity logged successfully") {
        setTimeout(() => {
          localStorage.clear();
          document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.href = "/login";
        }, 1000);
        // }

      }
    } catch (err) {
      console.error(err);
      setSnackbarType("error");
      setSnackbarTitle("Something went wrong");
      setSnackbar(true);
    }
  };

  const getUserBillingDetails = async () => {
    setLoading(true);

    try {
      const response = await adminServices.UserBillingDetails(userInfo.id);

      if (response?.ok) {
        const data = response.data;
        if (!data) {
          setBillingPlans(false);
        } else {
          setBillingPlans(data);
        }
      }
      setLoading(false)
    } catch (error) {
      console.log("Failed to fetch billing details:", error);
      setBillingPlans(null);
      setLoading(false)
    }
  };



  function parseAction(actionValue) {
    try {
      const obj = JSON.parse(actionValue);
      return obj.action || actionValue;
    } catch {
      return actionValue;
    }
  }
  function formatAction(str) {
    const formatted = str
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

    if (formatted === "Account Deletion Requested") {
      return "Account Deletion Request";
    }
    return formatted;
  }


  const getProfile = async () => {
    const res = await adminServices.getUserProfileDetails(id);
    setUserData(res.data ? res.data[0] : '')
  }

  useEffect(() => {
    getProfile()
  }, [])


  useEffect(() => {
    if (tabValue === 0) {
      getProfile()
    }
    if (tabValue === 2) {
      getUserBillingDetails()
    }
    if (tabValue === 3) {
      fetchNotificationPreferences();
    }
    if (tabValue === 4) {
      fetchUserActivityLogs();
      fetchLatestExportRequest();
      setPrivacyLoading(true);
      setTimeout(() => {
        setPrivacyLoading(false);
      }, 2000);

    }
  }, [tabValue])

  useEffect(() => {
    if (dialogType === 'changePassword') {
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setShowCurrentPassword(false);
      setShowNewPassword(false);
      setShowConfirmPassword(false);
    }
  }, [dialogType]);

  useEffect(() => {
    allcourseDetails?.CategoryDetails?.settings?.forEach(item => {
      switch (item.config_name) {

        case 'gender':
          setGenderDetails(item.data)
          break;
        case 'current_role':
          setRoleDetails(item.data);
          break;
        case 'work_experience':
          setWorkDetails(item.data);
          break;
        case 'education':
          setEducationDetails(item.data);
          break;
        case 'job':
          setJobDetails(item.data);
          break;
        case 'hear_about_us':
          setAboutDetails(item.data);
          break;
        case 'career_goal':
          setCarrierDetails(item.data);
          break;

        default:
          break;
      }
    });
  }, [allcourseDetails])

  const fetchCountries = async (key) => {
    try {
      const response = await adminServices.getLookUpData(key);

      if (response.ok) {
        setCountries(response.data.country);

      } else {
        console.error('Failed to fetch countries');
      }
    } catch (error) {
      console.error('Error fetching countries', error);
    }
  };

  const onComplete = () => {
    navigate('/auth/subscribe')
  }
  useEffect(() => {
    const key = 'country'
    fetchCountries(key);
  }, []);

  const getLoginUserDetails = async () => {
    const response3 = await loginServices.getUserInfo();
    if (response3.ok) {
      dispatch(loginSuccess(response3.data));
      identifyPosthogUser(response3.data);
    }
  };

  useEffect(() => {
    setIsClickedButton(false);
  }, [editField]);


  const [initial, setInitial] = useState({
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    dateOfBirth: '',
    education: "",
    careerGoal: "",
    currentRole: "",
    job: "",
    referral: "",
    workExperience: "",
    Intrest: "",
    photo: null,
    phone: ''
  })

  useEffect(() => {
    getDetails()
    dispatch(getCategoryDetails())
  }, [])

  const getDetails = async () => {
    const res = await adminServices.getBasicDetails();


    if (res.ok) {
      const { courseHashTags } = res.data;
      const uniqueHashTags = Array.from(new Set(courseHashTags.map(item => item.description)))
        .map(description => courseHashTags.find(item => item.description === description));
      setCategoryDetails(uniqueHashTags);
    }
  };

  useEffect(() => {
    if (userData) {
      setInitial({
        firstName: userData.first_name || '',
        lastName: userData.last_name !== null ? userData.last_name : '',
        email: userData.email || '',
        dateOfBirth: userData.birth_date || '',
        gender: userData.additional_info?.gender || null,
        education: userData.additional_info?.education || null,
        careerGoal: userData.additional_info?.careerGoal || null,
        currentRole: userData.additional_info?.currentRole || null,
        job: userData.additional_info?.job || null,
        referral: userData.additional_info?.referral || null,
        workExperience: userData.additional_info?.workExperience || null,
        Intrest: userData.additional_info?.interests || null,
        photo: userData?.additional_info?.profileImage || null,
        phone: userData.phone || userData.additional_info?.phone || "",
      });

      setSelectedTags(userData.additional_info?.interests || []);
      setSelectedDate(userData.birth_date || '');
      setPhone(userData?.phone || '');

      const interests = userData.additional_info?.interests || [];
      const courseHashTags = allcourseDetails?.CategoryDetails?.courseHashTags || [];
      const safeCategoryDetails = categoryDetails || [];

      const filterNewInterests = (interestsArr = [], courseTagsArr = []) =>
        interestsArr.filter(
          interest =>
            !courseTagsArr.some(
              tag => tag?.description === interest || tag?.code === interest
            )
        );

      if (userInfo?.role === 'USER_DTC') {
        setCategoryDetails([
          ...courseHashTags,
          ...filterNewInterests(interests, courseHashTags)
        ]);
      } else {
        setCategoryDetails([
          ...safeCategoryDetails,
          ...filterNewInterests(interests, safeCategoryDetails)
        ]);
      }
    }

  }, [userData]);



  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const fetchNotificationPreferences = async () => {
    try {
      setLoadingNotificationPrefs(true);
      const res = await adminServices.getNotificationPreferences();

      if (res?.ok) {
        const prefs = res.data?.notificationPreferences || {};
        const merged = {
          ...defaultNotificationPreferences,
          ...prefs,
        };

        setNotificationPreferences(merged);
        setOriginalPreferences(merged);
      } else {
        console.log("Failed to load notification preferences", res);
      }
    } catch (error) {
      console.error("Error loading notification preferences", error);
    } finally {
      setLoadingNotificationPrefs(false);
    }
  };

  const handleTogglePreference = (key) => {
    setNotificationPreferences((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getSwitchStyles = () => ({
    width: 44,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: '2px',
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#10b981', // Green color when ON
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#10b981',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: '#e5e7eb',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 20,
      height: 20,
    },
    '& .MuiSwitch-track': {
      borderRadius: 24 / 2,
      backgroundColor: '#d1d5db', // Gray color when OFF
      opacity: 1,
      transition: 'background-color 300ms',
    },
  });

  const handleSaveNotificationPreferences = async () => {
    try {
      setSavingNotificationPrefs(true);
      const res = await adminServices.updateNotificationPreferences(notificationPreferences);
      // const res = { ok: false };
      if (res?.ok) {
        setSnackbarType("success");
        setSnackbarTitle("Preferences for Notifications updated successfully!");
        setSnackbar(true);
        setOriginalPreferences(notificationPreferences);
        setIsEditingPrefs(false);
      } else {
        setSnackbarType("error");
        setSnackbarTitle(res?.data?.message || "Unable to update this preference. Please try again.");
        setSnackbar(true);
      }
    } catch (error) {
      setSnackbarType("error");
      console.error("Unable to update this preference. Please try again.", error);
      setSnackbarTitle("Something went wrong");
      setSnackbar(true);
    } finally {
      setSavingNotificationPrefs(false);
    }
  };

  const handleTagClick = (tagCode) => {
    if (tagCode === 'Others') {
      setShowOthersInput(true);
    } else {
      const isSelected = selectedTags.includes(tagCode);
      if (!isSelected && selectedTags?.length === 5) {
        setSnackbarTitle(' Only 5 items can be selected')
        setSnackbar(true)
        return
      }
      const updatedTags = isSelected
        ? selectedTags.filter(tag => tag !== tagCode)
        : [...selectedTags, tagCode];
      setSelectedTags(updatedTags);
    }
  };

  useMemo(() => {
    const initialData = [initial.firstName, initial.lastName, initial.email, phone, selectedDate, initial.gender, initial.education, initial.job, initial.currentRole, initial.careerGoal, initial.referral, initial.workExperience];


    const filledFieldsCount = initialData.filter(Boolean).length;
    const progressIncrement = filledFieldsCount * 4.16;

    let progress = 25 + progressIncrement;

    if (selectedTags.length > 0) {
      progress += 25;
    }
    setProgress(Math.min(progress, 100));
  }, [initial]);


  const handleSave = (data, phone, selectedDate) => {

    const validateNames = () => {
      if (!data.firstName) {
        setError({ firstNameError: 'First name is required' })
      }

      else {
        return true
      }

    }

    const validation = validateNames()
    if (validation === true) {
      setAlldata(data);
      const requiredFields = [data.firstName, data.lastName, data.email, phone, selectedDate, data.gender, data.education, data.job, data.currentRole, data.careerGoal, data.referral, data.workExperience];
      const filledFieldsCount = requiredFields.filter(Boolean).length;
      let progressIncrement = filledFieldsCount * 4.16;
      if (selectedTags.length > 0) {
        progressIncrement += 25;
      }
      setProgress(Math.min(100, 25 + progressIncrement));
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };


  const handleSaveOld = (data, phone, selectedDate) => {
    const validateNames = () => {
      if (!data.firstName) {
        setError({ firstNameError: 'First name is required' })
      }
      else {
        return true
      }

    }

    const validation = validateNames()
    if (validation === true) {
      setAlldata(data);
      const requiredFields = [data.firstName, data.lastName, data.email, phone, selectedDate, data.gender, data.education, data.job, data.currentRole, data.careerGoal, data.referral, data.workExperience];
      const filledFieldsCount = requiredFields.filter(Boolean).length;
      let progressIncrement = filledFieldsCount * 4.16;
      if (selectedTags.length > 0) {
        progressIncrement += 25;
      }
      setProgress(Math.min(100, 25 + progressIncrement));
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

  };
  const AlertIconView = ({ size = 20, shiftY = 0 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `translateY(${shiftY}px)` }}
    >
      <circle cx="12" cy="12" r="10" fill="#E89600" />
      <rect x="11" y="7" width="2" height="7" rx="1" fill="white" />
      <circle cx="12" cy="16.5" r="1" fill="white" />
    </svg>
  );

  const AlertIconViewNew = ({ size = 20, shiftY = 0 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `translateY(${shiftY}px)` }}
    >
      <circle cx="12" cy="12" r="10" fill="#6a6a6b" />
      <rect x="11" y="7" width="2" height="7" rx="1" fill="white" />
      <circle cx="12" cy="16.5" r="1" fill="white" />
    </svg>
  );


  const handleOpenDialog = (type) => {
    setDialogType(type);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogType("");
  };

  const validateProfileForm = (values) => {
    let isValid = true;
    const newErrors = {};

    if (!values.firstName || values.firstName.trim() === "") {
      newErrors.firstNameError = "First name is required";
      isValid = false;
    }


    setError(prev => ({ ...prev, ...newErrors }));
    return isValid;
  };


  const handleUpdateDetails = async (values, selectedDate) => {
    setError({ firstNameError: '', lastNameError: '', photoError: '' });
    const isValid = validateProfileForm(values);

    if (!isValid) {
      setUpdateLoading(false);
      return;
    }

    setUpdateLoading(true);

    const formData = new FormData();

    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName || '');
    formData.append("email", values.email);
    formData.append("phoneNumber", values.phone || '');
    formData.append("profession", values.job || '');
    formData.append("languageCode", values.languageCode || 'En');
    formData.append("gender", values.gender || '');
    formData.append("education", values.education || '');
    formData.append("careerGoal", values.careerGoal || '');
    formData.append("currentRole", values.currentRole || '');
    formData.append("workExperience", values.workExperience || '');
    formData.append("referral", values.referral || '');

    if (selectedTags?.length > 0) {
      formData.append("Intrest", JSON.stringify(selectedTags));
    }
    

 if (values.dateOfBirth) {
        formData.append("dateOfBirth", values.dateOfBirth);
    }


    if (values.photo instanceof File) {
      formData.append("photo", values.photo);
    }

    try {
      const response = await adminServices.Updateusercreation(id, formData);

      if (response.ok) {
        setSnackbarType("success");
        setSnackbarTitle("Profile updated successfully");
        setSnackbar(true);
        getProfile();
        getLoginUserDetails();
        logUserActivity("PROFILE_UPDATED", "Success");
        setEditField(false);

        if (userInfo?.role === 'AUTH_USER') {
          setTimeout(() => {
            navigate("/app/course");
          }, 800);
        } else if (userInfo?.role === 'SUPER_ADMIN' || userInfo?.role === 'CLIENT_ADMIN') {
          setTimeout(() => {
            navigate("/app/dashboard");
          }, 800);
        } else if (userInfo?.role === 'CONTENT_WRITER') {
          setTimeout(() => {
            navigate("/app/course");
          }, 800);
        }
      } else {
        setSnackbarType("error");
        setSnackbarTitle(response.data?.message || "Update failed");
        setSnackbar(true);
      }
    } catch (err) {
      console.error(err);
      setSnackbarType("error");
      setSnackbarTitle("Something went wrong");
      setSnackbar(true);
    }

    setUpdateLoading(false);
  };



  const handlePushDetails = () => {
    if (newTag && !selectedTags.includes(newTag)) {
      const isTagAlreadyInCategoryDetails = categoryDetails.some(item => item.description === newTag);

      if (isTagAlreadyInCategoryDetails) {
        setTimeout(() => { }, 1000)
        setSnackbarTitle(`The tag "${newTag}" is already a default name and cannot be added again.`);
        setSnackbar(true);
        return;
      }
      if (selectedTags?.length === 5) {
        setSnackbarTitle(' Only 5 items can be selected')
        setSnackbar(true)
      } else {
        setSelectedTags([...selectedTags, newTag]);
        setCategoryDetails([...categoryDetails, newTag]);
        setNewTag('');
        setShowOthersInput(false)
      }
    }
  }

  const handleCancel = () => {
    setNewTag('');
    setShowOthersInput(false);
  };

  const handleDetailChange = (newDetail) => {
    setDetail(newDetail);
  };

  const loadStripePortal = async () => {
    setLoadingButton(true)
    try {
      const currentUrl = window.location.href;
      const response = await adminServices.getCustomerPortal(currentUrl);

      if (response?.ok && response?.data?.url) {
        window.location.href = response.data.url;
      } else {
        console.error("Failed to load Stripe Portal", response);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingButton(false);
    }
  };



  const uniqueTagCodes = [
    ...new Set(categoryDetails.map(tag => typeof tag === 'object' ? tag.description : tag))
  ];


  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", maxWidth: "100%", overflow: "hidden" }}>
      {userInfo?.role === 'USER_DTC' &&
        <>

          <Container id="contii" maxWidth={false} sx={{
            marginTop: '65px',
            width: '100%',
            mx: 'auto',
            px: { xs: 1, sm: '6px', md: '26px', lg: '40px', xl: '60px' },
            '@media (max-width:1360px)': {
              px: '20px',
            },
            '@media (max-width:1280px)': {
              px: '26px',
            },
          }}
          >

            <Breadcrumbs
              aria-label="breadcrumb"
              sx={{
                // marginTop: '70px',
                padding: '15px',
                paddingLeft: '0px',
                paddingBottom: '5px',
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontWeight: '500'
              }}
              separator=">"
            >

              <Typography sx={{
                cursor: 'pointer',
                textDecoration: 'none',
                border: 'none',
                background: 'none', fontFamily: "Inter, sans-serif",
                fontSize: { xs: 15, sm: '12px !important', md: '12px !important' },
                fontWeight: '500'
              }}
                onClick={handleNavigation}
              >
                Dashboard
              </Typography>
              <Typography sx={{
                cursor: 'pointer',
                textDecoration: 'none',
                border: 'none',
                background: 'none', fontFamily: "Inter, sans-serif",
                fontSize: { xs: 15, sm: '12px !important', md: '12px !important' },
                fontWeight: '500',
                color: '#000'
              }}
              >
                Profile Settings
              </Typography>
            </Breadcrumbs>
            <Typography
              variant="h2"
              sx={{ width: "100%", fontSize: '24px !important', fontFamily: "Inter, sans-serif" }}
            >
              Profile Settings
            </Typography>
            {onboardinddetails?.result === null && tabValue === 0 && (
              <WorkspaceSetup comingfrom="profileskip" onComplete={onComplete} />
            )}
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 1, mb: 1 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant={isMobile ? "scrollable" : "standard"}
                scrollButtons={isMobile ? "auto" : false}
                allowScrollButtonsMobile
                sx={{
                  width: '100%',
                  mt: 1, mb: 3,
                  border: "1px solid #E1E6EF",
                  borderRadius: "8px",
                  '& .MuiTabs-indicator': {
                    display: 'none',
                  },
                  '& .MuiTabs-scroller': {
                    // avoid clipping the selected tab's rounded bg on mobile
                    overflow: isMobile ? 'auto !important' : 'hidden',
                  },
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    minHeight: '50px',
                    justifyContent: 'center',
                    gap: 0,
                    border: "none !important",
                    whiteSpace: 'nowrap',
                    '& .MuiTab-iconWrapper': {
                      marginRight: 0.4,
                    },
                    // Desktop: equal-width tabs. Mobile: size to content so scrolling works.
                    flex: { xs: '0 0 auto', sm: 1 },
                    px: { xs: 1.5, sm: 2 },
                    fontSize: { xs: '0.8rem', sm: '0.875rem' },
                    minWidth: { xs: 'auto', sm: 90 },
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#11387b',
                    color: '#fff !important',
                    fontWeight: 600,
                    borderRadius: '4px',
                    padding: { xs: '10px 12px', sm: '12px 16px' },
                  },
                }}
              >
                <Tab icon={<UserIcon style={{ width: 20, height: 20 }} />} label="Personal" iconPosition="start" sx={{ gap: 0 }} />
                <Tab icon={<CreditCardIcon style={{ width: 22, height: 22 }} />} label="Workspace Setup" iconPosition="start" sx={{ gap: 0 }} />
                <Tab icon={<CreditCardIcon style={{ width: 22, height: 22 }} />} label="Subscriptions" iconPosition="start" sx={{ gap: 0 }} />
                <Tab icon={<BellIcon style={{ width: 22, height: 22 }} />} label="Notifications" iconPosition="start" sx={{ gap: 0 }} />
                <Tab icon={<LockKeyhole style={{ width: 20, height: 20 }} />} label="Privacy" iconPosition="start" sx={{ gap: 0 }} />
              </Tabs>
            </Box>

            {/* </Container>

          <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, mb: 2 }}> */}
            <Box spacing={2} id="profileContainer" style={{ width: '100%' }}>

              {/* <Container maxWidth="xl" sx={{ width: '100%', px: { xs: 2, sm: 3, md: 0 } }}> */}
              <Box sx={{ mt: 2 }}>


                {tabValue === 0 && (
                  <Box style={{ marginTop: '0px !important' }}>


                    <Formik
                      initialValues={initial}
                      enableReinitialize
                    >
                      {({ handleChange, setFieldValue, values, errors, touched, resetForm }) => {
                        

                        const getProfileImage = () => {
                          if (values.photo instanceof File) {
                            return URL.createObjectURL(values.photo);
                          }

                          if (userData?.additional_info?.profileImage) {
                            return userData.additional_info.profileImage;
                          }

                          return "/default-profile.png";
                        };


                        return (
                          <Form style={{ padding: "20px 0px 20px 0px" }}>
                            <Grid container spacing={4}>
                              {/* Left Side - Profile Photo Section */}
                              {/* <Grid
                                item
                                xs={12}
                                md={3}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start'
                                }}
                                id='profile'
                              >

                                <Box
                                  sx={{
                                    width: { xs: 120, sm: 150, md: 180 },
                                    height: { xs: 120, sm: 150, md: 180 },
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                    mb: 2,
                                    backgroundColor: "#E9EBF8",
                                    cursor: "pointer",
                                  }}
                                >
                                  {(values.photo || userData?.additional_info?.profileImage) ? (
                                    <img
                                      src={getProfileImage()}
                                      alt="Profile"
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <CameraAltOutlinedIcon sx={{ color: "#595959", width: 70, height: 70 }} />
                                  )}
                                </Box>
             
                                <Button
                                  variant="contained"
                                  component="label"
                                  sx={{
                                    mb: 1,
                                    borderRadius: '4px',
                                    backgroundColor: !editField ? "#E0E0E0" : "#1976d2",
                                    color: !editField ? "#9E9E9E" : "#fff",
                                    cursor: !editField ? "not-allowed" : "pointer",
                                    "&:hover": {
                                      backgroundColor: !editField ? "#E0E0E0" : "#1565c0",
                                    }
                                  }}
                                >
                                  Change Photo

                                  <input
                                    type="file"
                                    hidden
                                    accept="image/jpeg, image/png"
                                    disabled={!editField}
                                    onChange={(e) => {
                                      const file = e.target.files?.[0];

                                      if (!file) return;

                                      if (file.size > 2 * 1024 * 1024) {
                                        setError(prev => ({
                                          ...prev,
                                          photoError:
                                            "Photo is more than 2 MB. Please upload an image within the max size limit"
                                        }));
                                        e.target.value = "";
                                        return;
                                      }

                                      setFieldValue("photo", file);
                                      setError(prev => ({ ...prev, photoError: "" }));

                                      e.target.value = "";
                                    }}
                                  />
                                </Button>

                                {error.photoError && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    sx={{ textAlign: "center", width: "100%" }}
                                  >
                                    {error.photoError}
                                  </Typography>
                                )}

                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  sx={{ mt: 1, textAlign: 'center' }}
                                >
                                  JPG or PNG • Max 2 MB
                                </Typography>
                              </Grid> */}

                              <Grid
                                item
                                xs={12}
                                md={3}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                {(() => {
                                  const hasImage =
                                    values.photo || userData?.additional_info?.profileImage;

                                  return (
                                    <>
                                      {/* Image Wrapper */}
                                      <Box
                                        sx={{
                                          position: "relative",
                                          width: { xs: 120, sm: 150, md: 180 },
                                          height: { xs: 120, sm: 150, md: 180 },
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                          mb: 2,
                                          backgroundColor: "#E9EBF8",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {hasImage ? (
                                          <>
                                            <img
                                              src={getProfileImage()}
                                              alt="Profile"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                              }}
                                            />

                                            {editField && (
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setFieldValue("photo", null);

                                                  if (userData?.additional_info) {
                                                    userData.additional_info.profileImage = null;
                                                  }

                                                  setError(prev => ({ ...prev, photoError: "" }));
                                                }}
                                                sx={{
                                                  position: "absolute",
                                                  top: 23,
                                                  right: 23,
                                                  backgroundColor: "rgba(0,0,0,0.6)",
                                                  color: "#fff",
                                                  "&:hover": {
                                                    backgroundColor: "rgba(0,0,0,0.8)",
                                                  },
                                                }}
                                              >
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          </>
                                        ) : (
                                          <CameraAltOutlinedIcon
                                            sx={{ color: "#595959", width: 70, height: 70 }}
                                          />
                                        )}
                                      </Box>

                                      {/* Change Photo Button */}
                                      <Button
                                        variant="contained"
                                        disabled={!editField}
                                        component="label"
                                        sx={{
                                          mb: 1,
                                          borderRadius: '4px',
                                          backgroundColor: !editField ? "#E0E0E0" : "#1976d2",
                                          color: !editField ? "#9E9E9E" : "#fff",
                                          cursor: !editField ? "not-allowed" : "pointer",
                                          "&:hover": {
                                            backgroundColor: !editField ? "#E0E0E0" : "#1565c0",
                                          }
                                        }}
                                      >
                                        Change Photo
                                        <input
                                          type="file"
                                          hidden
                                          accept="image/jpeg, image/png"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (!file) return;

                                            if (file.size > 2 * 1024 * 1024) {
                                              setError(prev => ({
                                                ...prev,
                                                photoError:
                                                  "Photo is more than 2 MB. Please upload an image within the max size limit",
                                              }));
                                              e.target.value = "";
                                              return;
                                            }

                                            setFieldValue("photo", file);
                                            setError(prev => ({ ...prev, photoError: "" }));
                                            e.target.value = "";
                                          }}
                                        />
                                      </Button>

                                      {/* Error */}
                                      {error.photoError && (
                                        <Typography variant="caption" color="error">
                                          {error.photoError}
                                        </Typography>
                                      )}

                                      <Typography variant="caption" color="textSecondary">
                                        JPG or PNG • Max 2 MB
                                      </Typography>
                                    </>
                                  );
                                })()}
                              </Grid>


                              {/* Right Side - Form Fields */}
                              <Grid item xs={12} md={9}>
                                <Grid container spacing={3}>

                                  {/* First Name */}
                                  <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      First Name<span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      name="firstName"
                                      placeholder="Enter first name"
                                      value={values.firstName}
                                      disabled={!editField}
                                      onChange={(e) => {
                                        const sanitizedValue = e.target.value
                                          .replace(/[^a-zA-Z\s]/g, '')
                                          .slice(0, 100);
                                        setFieldValue("firstName", sanitizedValue);
                                        if (error.firstNameError) {
                                          setError(prevError => ({ ...prevError, firstNameError: '' }));
                                        }
                                      }}
                                      onBlur={() => {
                                        if (!values.firstName) {
                                          setError(prevError => ({ ...prevError, firstNameError: 'First name is required' }));
                                        }
                                      }}
                                      error={Boolean(error.firstNameError)}
                                      helperText={error.firstNameError}
                                      size="small"
                                      sx={{
                                        backgroundColor: editField ? "#fff" : "none",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            borderColor: editField ? "#ccc" : "#e5e7eb",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: editField ? "#000" : "#e5e7eb",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#000 !important",
                                            borderWidth: "1px",
                                          },
                                        },
                                      }}
                                    />
                                  </Grid>

                                  {/* Last Name */}
                                  <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      Last Name
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      name="lastName"
                                      placeholder="Enter last name"
                                      value={values.lastName}
                                      disabled={!editField}
                                      onChange={(e) => {
                                        const sanitizedValue = e.target.value
                                          .replace(/[^a-zA-Z\s]/g, '')
                                          .slice(0, 100);
                                        setFieldValue("lastName", sanitizedValue);

                                        if (error.lastNameError) {
                                          setError(prevError => ({ ...prevError, lastNameError: '' }));
                                        }
                                      }}
                                      size="small"
                                      sx={{
                                        backgroundColor: editField ? "#fff" : "none",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            borderColor: editField ? "#ccc" : "#e5e7eb",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: editField ? "#000" : "#e5e7eb",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#000 !important",
                                            borderWidth: "1px",
                                          },
                                        },
                                      }}

                                    />
                                  </Grid>

                                  {/* Email */}
                                  <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                      <Typography sx={{ fontWeight: 500 }}>Email Address</Typography>

                                      <CheckCircleIcon style={{ color: "#22C55E", width: 22, height: 22 }} />
                                      <Typography sx={{ color: "#22C55E", fontSize: "0.85rem", fontWeight: 500 }}>
                                        Verified
                                      </Typography>
                                    </Box>
                                    <TextField
                                      fullWidth
                                      name="email"
                                      placeholder="Enter email"
                                      value={values.email}
                                      // onChange={handleChange}
                                      error={touched.email && Boolean(errors.email)}
                                      helperText={touched.email && errors.email}
                                      disabled
                                      size="small"
                                    />
                                    {editField && (
                                      <Typography
                                        sx={{ color: "red", fontSize: "12px !important", mt: 0.5, ml: 0.5 }}
                                      >
                                        (You cannot change your email. Sorry!)
                                      </Typography>
                                    )}
                                  </Grid>

                                  {/* Date of Birth */}
                                  <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      Date of Birth
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                      <DatePicker
                                        value={values.dateOfBirth ? new Date(values.dateOfBirth) : null}
                                        disabled={!editField}
                                        maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                        onChange={(newValue) => {
                                          const formattedDate = newValue
                                            ? newValue.toISOString().split("T")[0]
                                            : "";
                                          setFieldValue("dateOfBirth", formattedDate);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            sx={{
                                              backgroundColor: editField ? "#fff" : "none",
                                              "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                  borderColor: editField ? "#ccc" : "#e5e7eb",
                                                },
                                                "&:hover fieldset": {
                                                  borderColor: editField ? "#000" : "#e5e7eb",
                                                },
                                                "&.Mui-focused fieldset": {
                                                  borderColor: "#000 !important",
                                                  borderWidth: "1px",
                                                },
                                              },
                                            }}
                                            fullWidth
                                            {...params}
                                            placeholder="MM/DD/YYYY"
                                            size="small"
                                            inputProps={{
                                              ...params.inputProps,
                                              readOnly: true,
                                            }}
                                          />
                                        )}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            fullWidth: true,
                                          },
                                          day: {
                                            sx: {
                                              "&.MuiPickersDay-daySelected": {
                                                backgroundColor: "#1976d2 !important",
                                                color: "#fff !important",
                                              },
                                              "&.MuiPickersDay-daySelected:hover": {
                                                backgroundColor: "#115293 !important",
                                              }
                                            }
                                          }
                                        }}


                                      // sx={{
                                      //   backgroundColor: editField ? "#fff" : "none",
                                      //   "& .MuiOutlinedInput-root": {
                                      //     "& fieldset": {
                                      //       borderColor: editField ? "#ccc" : "#e5e7eb",
                                      //     },
                                      //     "&:hover fieldset": {
                                      //       borderColor: editField ? "#000" : "#e5e7eb",
                                      //     },
                                      //     "&.Mui-focused fieldset": {
                                      //       borderColor: "#000 !important",
                                      //       borderWidth: "1px",
                                      //     },
                                      //   },
                                      // }}
                                      />
                                    </LocalizationProvider>

                                  </Grid>

                                  {/* Phone Number */}
                                  {/* <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      Phone Number
                                    </Typography>
                                    <PhoneNumber
                                      fullWidth
                                      disabled={!editField}
                                      country={"us"}
                                      value={phone}
                                      onChange={(value) => setFieldValue("phone", value)}

                                      containerStyle={{
                                        width: "100%",
                                        position: "relative",
                                        zIndex: 1300,
                                      }}
                                      dropdownStyle={{
                                        position: "fixed",
                                        top: "auto",
                                        left: "auto",
                                        zIndex: 999999,
                                        borderRadius: "8px",
                                        maxHeight: "260px",
                                        overflowY: "auto",
                                      }}
                                      menuStyle={{
                                        maxHeight: "260px",
                                        overflowY: "auto",
                                        zIndex: 999999,
                                      }}

                                      inputStyle={{
                                        width: "100%",
                                        height: "43px",
                                        borderRadius: "8px",
                                        paddingLeft: "48px",
                                        backgroundColor: editField ? "#fff" : "transparent",
                                        border: editField ? "1px solid #cacaca" : "1px solid #e5e7eb",
                                      }}
                                      buttonStyle={{
                                        width: "40px",
                                        borderRadius: "8px 0 0 8px",
                                        backgroundColor: editField ? "#fff" : "transparent",
                                        border: editField ? "1px solid #cacaca" : "1px solid #e5e7eb",
                                      }}
                                    />



                                  </Grid> */}

                                  <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      Phone Number <span style={{ color: 'red' }}>*</span>
                                    </Typography>

                                    {/* <PhoneInput
                                      localization={es}
                                      fullWidth
                                      disabled={!editField}
                                      country="us"
                                      value={values.phone}
                                      onChange={(value, country) => {
                                        setFieldValue('phone', value);
                                        setFieldValue('country', country.countryCode);
                                      }}

                                      inputProps={{
                                        name: 'phone',
                                      }}

                                      containerStyle={{
                                        width: "100%",
                                        position: "relative",
                                        zIndex: 1300,
                                      }}

                                      inputStyle={{
                                        width: "100%",
                                        height: "43px",
                                        borderRadius: "8px",
                                        paddingLeft: "48px",
                                        border:
                                          errors.phone && touched.phone
                                            ? "1px solid #d32f2f"
                                            : "1px solid #cacaca",
                                      }}
                                    /> */}
                                    <PhoneInput
                                      localization={es}
                                      fullWidth
                                      disabled={!editField}
                                      country="us"
                                      value={values.phone}
                                      onChange={(value, country) => {
                                        setFieldValue('phone', value);
                                        setFieldValue('country', country.countryCode);
                                      }}
                                      inputProps={{ name: "phone", placeholder: "" }}
                                      containerStyle={{
                                        width: "100%",
                                        position: "relative",
                                      }}

                                      inputStyle={{
                                        width: "100%",
                                        height: "43px",
                                        borderRadius: "8px",
                                        paddingLeft: "48px",
                                        border:
                                          errors.phone && touched.phone
                                            ? "1px solid #d32f2f"
                                            : "1px solid #cacaca",
                                      }}

                                      dropdownStyle={{
                                        zIndex: 2000,
                                        position: "absolute",
                                      }}
                                    />


                                    {errors.phone && touched.phone && (
                                      <FormHelperText error>
                                        {errors.phone}
                                      </FormHelperText>
                                    )}
                                  </Grid>




                                  {/* Profession */}
                                  <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                      Profession
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      name="job"
                                      placeholder="Enter profession"
                                      value={values.job || ""}
                                      disabled={!editField}
                                      onChange={(e) => {
                                        const limitedValue = e.target.value.slice(0, 100);
                                        setFieldValue("job", limitedValue);
                                      }}
                                      error={touched.job && Boolean(errors.job)}
                                      helperText={touched.job && errors.job}
                                      size="small"
                                      sx={{
                                        backgroundColor: editField ? "#fff" : "none",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            borderColor: editField ? "#ccc" : "#e5e7eb",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: editField ? "#000" : "#e5e7eb",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#000 !important",
                                            borderWidth: "1px",
                                          },
                                        },
                                      }}

                                    />
                                  </Grid>

                                  <Grid item xs={12}>
                                    <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                      {!editField ? (
                                        <Button
                                          variant="contained"
                                          sx={{
                                            mb: 1,
                                            borderRadius: '4px',
                                            backgroundColor: "#1976d2",
                                            color: "#fff",
                                            cursor: "pointer",
                                            "&:hover": {
                                              backgroundColor: "#1565c0",
                                            }
                                          }}
                                          onClick={() => setEditField(true)}
                                        >
                                          <PencilSquareIcon strokeWidth={2} style={{ width: 22, height: 22, marginRight: 5 }} />Edit Info
                                        </Button>
                                      ) : (
                                        <>
                                          <Button
                                            variant="outlined"
                                            sx={{
                                              mb: 1,
                                              mr: 1,
                                              px: 4,
                                              border: 'none',
                                              backgroundColor: 'transparent',
                                              color: "#000",
                                              textTransform: "none",
                                              borderRadius: "none",
                                              "&:hover": {
                                                backgroundColor: "transparent !important",
                                                border: 'none',
                                              },
                                            }}
                                            onClick={() => {
                                              getProfile();
                                              setPhone('');
                                              resetForm({ values: initial });
                                              setEditField(false);
                                              setError({ firstNameError: '', lastNameError: '', photoError: '' })
                                            }}
                                          >
                                            Cancel
                                          </Button>


                                          <Button
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                              mb: 1,
                                              borderRadius: "4px",
                                              backgroundColor: UpdateLoading ? "#1565c0" : "#1976d2",
                                              color: "#fff",
                                              cursor: UpdateLoading ? "not-allowed" : "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                              opacity: UpdateLoading ? 0.9 : 1,
                                              "&:hover": {
                                                backgroundColor: UpdateLoading ? "#1565c0" : "#1565c0",
                                              },
                                            }}
                                            disabled={UpdateLoading}
                                            onClick={() => handleUpdateDetails(values, selectedDate)}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              style={{ width: 18, height: 18 }}
                                            >
                                              <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7z" />
                                              <polyline points="17 3 17 8 7 8 7 3" />
                                              <rect x="7" y="13" width="10" height="8" rx="1" />
                                            </svg>

                                            {UpdateLoading ? "Saving..." : "Save Changes"}
                                            {UpdateLoading && (
                                              <CircularProgress size={16} sx={{ color: "#1976d2" }} />
                                            )}
                                          </Button>

                                        </>
                                      )}
                                    </Grid>

                                  </Grid>

                                </Grid>
                              </Grid>

                            </Grid>
                          </Form>
                        )
                      }}
                    </Formik>




                  </Box>
                )}
                {tabValue === 1 && (
                  <>
                    <WorkspaceSetup comingfrom="profile" onComplete={onComplete}
                    // onFinish={(config) => {
                    //   console.log('Workspace config saved:', config);
                    //   // call your API here, e.g. adminServices.saveWorkspaceSetup(config)
                    // }}
                    />
                  </>
                )}
                {tabValue === 2 && (
                  <>
                    <Box sx={{ mt: 3, px: { xs: 2, sm: 3, md: 4 }, display: 'flex', justifyContent: 'center' }}>
                      {loading ? (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          height="60vh"
                          width="100%"
                        >
                          <CircularProgress color="primary" size={60} thickness={4}
                            sx={{
                              color: "#133E87",
                            }} />
                          <Typography variant="h6" sx={{ mt: 2, color: '#133E87' }}>
                            Loading Subscriptions ...
                          </Typography>
                        </Box>
                      ) : (
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{
                              // p: '0px 0px 32px 32px',
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >

                            {billingPlans === false && (
                              <Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mt: 4,
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  src={noSubscriptions}
                                  alt="No Subscriptions"
                                  style={{ width: "280px", marginBottom: "20px" }}
                                />

                                <Typography variant="h5" fontWeight={600}>
                                  No Active Subscriptions
                                </Typography>

                                <Typography
                                  variant="body1"
                                  sx={{ maxWidth: "500px", mt: 1, color: "text.secondary" }}
                                >
                                  You currently don’t have any active subscriptions. Browse our courses and
                                  assessments to get started with your learning journey.
                                </Typography>

                                <Box sx={{ display: "flex", gap: 2, mt: 3, flexDirection: 'column' }}>
                                  <Button variant="outlined"
                                    onClick={handleNavigationCourses} sx={{
                                      mb: 1, mr: 1, borderRadius: '4px',
                                      px: 4,
                                      borderColor: "#3F3F3F",
                                      color: "#3F3F3F",
                                      backgroundColor: "#fff",
                                      textTransform: "none",
                                      "&:hover": {
                                        borderColor: "#3F3F3F",
                                        backgroundColor: "#dadadaff",
                                      }
                                    }}>  <AcademicCapIcon style={{ width: 22, height: 22, marginRight: 5 }} />Browse Courses</Button>
                                  <Button variant="outlined"
                                    onClick={handleNavigationAssessments} sx={{
                                      mb: 1, mr: 1, borderRadius: '4px',
                                      px: 4,
                                      borderColor: "#3F3F3F",
                                      color: "#3F3F3F",
                                      backgroundColor: "#fff",
                                      textTransform: "none",
                                      "&:hover": {
                                        borderColor: "#3F3F3F",
                                        backgroundColor: "#dadadaff",
                                      }
                                    }}>  <ClipboardList style={{ width: 22, height: 22, marginRight: 5 }} />Browse Test series</Button>
                                </Box>
                              </Box>
                            )}

                            {billingPlans === true && (
                              <>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>

                                  <Box
                                    sx={{
                                      p: '20px !important',
                                      width: "95%",
                                      // maxWidth: "900px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: "#E9EFFD",
                                      borderRadius: "12px",
                                      textAlign: "center",
                                    }}

                                  >
                                    <img
                                      src={shieldCheck}
                                      alt="Secure Payment"
                                      style={{ width: "50px", marginBottom: "20px", marginTop: "18px" }}
                                    />

                                    <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                                      Secure Payment Management
                                    </Typography>
                                    <Typography variant="body1" sx={{ mt: 1, color: "text.secondary", px: 1 }}>
                                      Your subscription and payment details are securely managed by Stripe, our trusted payment gateway. We prioritize your security and privacy by ensuring that we never store, process, or have access to your credit card information, banking details, or any sensitive payment data on our servers.
                                    </Typography>
                                    <Typography variant="body1" sx={{ mt: 3, color: "text.secondary", px: 2, py: 2 }}>
                                      All transactions are encrypted and processed directly through Stripe's
                                      <Box component="span" fontWeight="700" sx={{ color: "text.primary" }}>
                                        {" "}PCI-DSS compliant infrastructure
                                      </Box>.
                                      This means your payment information is protected by bank-level security
                                      standards, giving you peace of mind with every transaction. Your financial
                                      data remains completely secure and is never exposed to our platform.
                                    </Typography>

                                  </Box>

                                  <Button
                                    variant="contained"
                                    onClick={loadStripePortal}
                                    disabled={loading}
                                    sx={{
                                      mt: 4,
                                      minWidth: 230,
                                      py: 1.3,
                                      fontSize: "16px",
                                      borderRadius: "8px",
                                      backgroundColor: "#225AD6",
                                      "&:hover": {
                                        backgroundColor: "#4C7FF0",
                                      },
                                    }}
                                  >
                                    {loadingButton ? (
                                      <CircularProgress size={22} sx={{ color: "white" }} />
                                    ) : (
                                      "Manage Subscriptions"
                                    )}
                                  </Button>
                                </Box>

                                {/* <Box
                                    sx={{
                                      p: '20px !important',
                                      width: '95%',
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: "#E9EFFD",
                                      borderRadius: "12px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <img
                                      src={shieldCheck}
                                      alt="Secure Payment"
                                      style={{ width: "50px", marginBottom: "20px" }}
                                    />

                                    <Typography variant="h5" fontWeight={700}>
                                      Secure Payment Management
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
                                      Your subscription and payment details are securely managed by Stripe, our trusted payment gateway. We prioritize your security and privacy by ensuring that we never store, process, or have access to your credit card information, banking details, or any sensitive payment data on our servers.
                                    </Typography>
                                    <Typography variant="body1" sx={{ mt: 3, color: "text.secondary" }}>
                                      All transactions are encrypted and processed directly through Stripe's
                                      <Box component="span" fontWeight="700" sx={{ color: "text.primary" }}>
                                        {" "}PCI-DSS compliant infrastructure
                                      </Box>.
                                      This means your payment information is protected by bank-level security
                                      standards, giving you peace of mind with every transaction. Your financial
                                      data remains completely secure and is never exposed to our platform.
                                    </Typography>


                                 



                                  </Box>

                                  <Button
                                      variant="contained"
                                      onClick={loadStripePortal}
                                      disabled={loading}
                                      sx={{
                                        mt: 3,
                                        minWidth: 200,
                                        borderRadius: "8px",
                                        backgroundColor: "#225AD6",
                                        "&:hover": {
                                          backgroundColor: "#4C7FF0",
                                        },
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 1,
                                      }}
                                    >
                                      {loadingButton ? (
                                        <CircularProgress size={22} sx={{ color: "white" }} />
                                      ) : (
                                        "Manage Subscriptions"
                                      )}
                                    </Button> */}
                              </>
                            )}

                          </Grid>
                        </Grid>
                      )}


                    </Box>
                  </>
                )}

                {tabValue === 3 && (
                  <Box sx={{ mt: 3, px: { xs: 2, sm: 3, md: 4 } }}>
                    <Box sx={{ mb: 3, border: '1px solid #e0e0e0', boxShadow: 'none', borderRadius: '6px' }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 3, ml: 3, mb: 1 }}>
                        {/* <VerifiedUserIcon sx={{ fontSize: 28 }} /> */}
                        <ShieldCheck style={{ width: 20, height: 20 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          Course Category Preferences
                        </Typography>
                      </Box>

                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, ml: 4 }}>
                        For your security, these essential notifications are always on.
                      </Typography>

                      <Box component="ul" sx={{ pl: 3, mb: 2, ml: 8, '& li': { pl: 1, mb: 0.5 } }}>
                        <li style={{ paddingLeft: '8px' }}>
                          <Typography variant="body2" color="text.secondary">
                            Password reset emails
                          </Typography>
                        </li>
                        <li style={{ paddingLeft: '8px' }}>
                          <Typography variant="body2" color="text.secondary">
                            Billing and payment confirmation emails
                          </Typography>
                        </li>
                        <li style={{ paddingLeft: '8px' }}>
                          <Typography variant="body2" color="text.secondary">
                            Security alerts about your account (via email)
                          </Typography>
                        </li>
                      </Box>

                    </Box>

                    <Card
                      sx={{
                        mb: 4,
                        border: '1px solid #e0e0e0',
                        boxShadow: 'none',
                        bgcolor: '#f9f9f9'
                      }}
                    >
                      <CardContent>
                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: { xs: 'wrap', sm: 'nowrap' },
                          gap: 2
                        }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box
                              sx={{
                                width: 48,
                                height: 48,
                                borderRadius: '50%',
                                bgcolor: '#25D366',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                              }}
                            >
                              <WhatsAppIcon sx={{ fontSize: 28, color: '#fff' }} />

                            </Box>
                            <Box>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5, fontSize: 18 }}>
                                WhatsApp Notifications are coming soon!
                              </Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '12px' }}>
                                Get updates directly on your phone
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>

                    <Grid container spacing={4}>
                      {/* course notifications */}
                      <Grid item xs={12} lg={6}>
                        <Card sx={{ border: '1px solid #e0e0e0', boxShadow: 'none', height: '100%', backgroundColor: '#f9f9f9' }}>
                          <CardContent>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Course Notifications
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                              Choose how you want to receive notifications to your email
                            </Typography>

                            <Box sx={{ mb: 3 }}>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                // alignItems: 'flex-start',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    New Course Launch
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                    Get notified when new courses are launched
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.newCourseLaunch}
                                  onChange={() => handleTogglePreference("newCourseLaunch")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                            <Box sx={{ mb: 3 }}>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    Promotional Offers
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                    All our course related offers delivered directly to your email
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.promotionalOffers}
                                  onChange={() => handleTogglePreference("promotionalOffers")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                            {/* Course Announcements */}
                            <Box>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    Course Announcements
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                    Milestone, Module, and Skillset IQ completion updates
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.courseAnnouncements}
                                  onChange={() => handleTogglePreference("courseAnnouncements")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                          </CardContent>
                        </Card>
                      </Grid>

                      {/* Assessment Notifications */}
                      <Grid item xs={12} lg={6}>
                        <Card sx={{ border: '1px solid #e0e0e0', boxShadow: 'none', height: '100%', backgroundColor: '#f9f9f9' }}>
                          <CardContent>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Assessment Notifications
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                              Choose how you want to receive notifications to your email
                            </Typography>

                            {/* New Assessments Launch */}
                            <Box sx={{ mb: 3 }}>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    New Assessments Launch
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                    Be the first to be notified when new assessments are launched
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.newAssessmentLaunch}
                                  onChange={() => handleTogglePreference("newAssessmentLaunch")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                            {/* Study Guides */}
                            <Box sx={{ mb: 3 }}>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    Discounts and Offers
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    Special offers on all Assessment categories
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.discountsAndOffers}
                                  onChange={() => handleTogglePreference("discountsAndOffers")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                            {/* Grades and Completion */}
                            <Box>
                              <Box sx={{
                                display: 'flex',
                                p: '8px !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                mb: 1
                              }}>
                                <Box sx={{ flex: 1, pr: 2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    Grades and Completion
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    Receive updates on your exam result and analytics
                                  </Typography>
                                </Box>
                                <Switch
                                  checked={notificationPreferences.gradesAndCompletion}
                                  onChange={() => handleTogglePreference("gradesAndCompletion")}
                                  disabled={!isEditingPrefs || loadingNotificationPrefs || savingNotificationPrefs}
                                  sx={getSwitchStyles()}
                                />
                              </Box>
                            </Box>

                          </CardContent>
                        </Card>
                      </Grid>

                      <Grid item xs={12} lg={12}>
                        <Box sx={{ mt: 1, mb: 1, mr: 1.5, display: 'flex', justifyContent: 'center' }}>
                          {isEditingPrefs && (
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                px: 3,
                                border: 'none',
                                backgroundColor: 'transparent',
                                color: "#000",
                                textTransform: "none",
                                borderRadius: "none",
                                "&:hover": {
                                  backgroundColor: "transparent !important",
                                  border: 'none',
                                },
                              }}
                              onClick={() => {
                                setNotificationPreferences(originalPreferences);
                                setIsEditingPrefs(false);
                              }}
                              disabled={savingNotificationPrefs}
                            >
                              Cancel
                            </Button>
                          )}


                          <Button
                            variant="contained"
                            size="small"
                            sx={{
                              textTransform: 'none',
                              backgroundColor: '#225AD6',
                              borderRadius: '4px',
                              '&:hover': { backgroundColor: '#225AD6' },
                            }}
                            onClick={() => {
                              if (!isEditingPrefs) {
                                setIsEditingPrefs(true);
                              } else {
                                handleSaveNotificationPreferences();
                              }
                            }}
                            disabled={savingNotificationPrefs || loadingNotificationPrefs}
                          >
                            {isEditingPrefs ? (
                              <SaveOutlinedIcon sx={{ fontSize: 18, color: "#fff", mr: 1 }} />) : (
                              // <BorderColorIcon sx={{ fontSize: 18, color: "#fff", mr: 1 }} />
                              <PencilSquareIcon strokeWidth={2} style={{ width: 22, height: 22, marginRight: 5 }} />
                            )
                            }
                            {/* eslint-disable-next-line no-nested-ternary */}
                            {isEditingPrefs
                              ? (savingNotificationPrefs ? "Saving..." : "Save Changes")
                              : "Edit Preferences"}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                {tabValue === 4 && (

                  privacyLoading ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      height="60vh"
                      width="100%"
                    >
                      <CircularProgress
                        size={60}
                        thickness={4}
                        sx={{ color: "#133E87" }}
                      />
                      <Typography variant="h6" sx={{ mt: 2, color: "#133E87" }}>
                        Loading Privacy Settings ...
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ mt: 3, px: { xs: 2, sm: 3, md: 4 } }}>

                      {/* --- YOUR DATA --- */}
                      <Box sx={{ border: '1px solid #e5e7eb', p: '10px 14px !important', mb: 5, borderRadius: '6px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <svg
                            viewBox="0 0 24 24"
                            width="26"
                            height="26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z"
                              stroke="#000000"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <circle cx="12" cy="12" r="3" fill="#000000" />
                          </svg>
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Your Data
                          </Typography>
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Access, download, and manage your data on request
                        </Typography>

                        {/* Activity Log */}
                        <Box
                          sx={{
                            border: '1px solid #E5E7EB',
                            borderRadius: 1,
                            mb: 2,
                            // p: '4px 8px !important',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: 'column',
                            gap: 2,
                          }}
                        >
                          <>
                            {/* Initial Collapsed View */}
                            <Box
                              sx={{
                                // border: '1px solid #E5E7EB',
                                // borderRadius: 1,
                                // mb: 2,
                                padding: '8px 14px !important', width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: { xs: 'column', sm: 'row' },
                                gap: 2,
                              }}
                            >
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                  Activity log
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  See recent sign-ins, actions, and devices (for 3 months)
                                </Typography>
                              </Box>

                              <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                  mb: 0.5, mt: 0.5,
                                  mr: 1, borderRadius: '4px',
                                  px: 4, lineHeight: 1,
                                  borderColor: "#CCCCCC",
                                  color: "#000",
                                  // backgroundColor: "#fff",
                                  textTransform: "none",

                                  "&:hover": {
                                    borderColor: "#ccc",
                                    backgroundColor: "#EEE",
                                  }
                                }}
                                onClick={handleToggleLog}
                              >
                                {showActivityLog ? "Close" : "View Log"}
                              </Button>
                            </Box>


                            {/* Dialog/Modal with Activity Log Table */}
                            {showActivityLog && (
                              <>
                                <Box
                                  sx={{
                                    border: "1px solid #E5E7EB",
                                    borderRadius: 0.8,
                                    p: '8px !important', width: '95%',
                                    background: "#FFFFFF",
                                  }}
                                >
                                  {/* Desktop Table */}
                                  <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <TableContainer>
                                      <Table>
                                        <TableHead sx={{ bgcolor: "#F0FDF4" }}>
                                          <TableRow>
                                            <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Device</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Location</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                          </TableRow>
                                        </TableHead>

                                        <TableBody>
                                          {paginatedData.map((row, index) => (
                                            <TableRow key={index}>
                                              <TableCell>{formatAction(mapActionLabel(parseAction(row.action)))}</TableCell>

                                              <TableCell>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                  {row.deviceType === "mobile" ? (
                                                    <Smartphone style={{ width: 22, height: 22 }} />
                                                  ) : (
                                                    <Monitor style={{ width: 22, height: 22 }} />
                                                  )}
                                                  <Typography>{row.deviceLabel}</Typography>
                                                </Box>
                                              </TableCell>

                                              <TableCell>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                  <MapPin style={{ width: 22, height: 22, marginRight: 5 }} />
                                                  {row.location}
                                                </Box>
                                              </TableCell>

                                              <TableCell>
                                                {/* {row.created_date} */}
                                                {moment(row.created_date).format("DD MMM YYYY")}
                                              </TableCell>

                                              <TableCell>
                                                <Chip
                                                  label={
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        justifyContent: "center",
                                                      }}
                                                    >
                                                      {row.status === "Withdrawn" ? (
                                                        <AlertIconViewNew
                                                          size={20}
                                                          shiftY={2}
                                                          style={{ width: 18, height: 18 }}
                                                        />
                                                      ) : (
                                                        <>
                                                          {row.status === "Success" ? <FaceSmileIcon
                                                            style={{
                                                              width: 20,
                                                              height: 20,
                                                              color:
                                                                row.status === "Success"
                                                                  ? "#2E7D32"
                                                                  : row.status === "Processing"
                                                                    ? "#E89600"
                                                                    : row.status === "Withdrawn"
                                                                      ? "#EEEEEE"
                                                                      : "#D32F2F"
                                                            }}
                                                          />
                                                            :

                                                            <FaceFrownIcon
                                                              style={{
                                                                width: 20,
                                                                height: 20,
                                                                color:
                                                                  row.status === "Success"
                                                                    ? "#2E7D32"
                                                                    : row.status === "Processing"
                                                                      ? "#E89600"
                                                                      : row.status === "Withdrawn"
                                                                        ? "#EEEEEE"
                                                                        : "#D32F2F"
                                                              }}
                                                            />}
                                                        </>
                                                      )}
                                                      {row.status}
                                                    </Box>
                                                  }
                                                  sx={{
                                                    width: "130px",
                                                    borderRadius: "999px",
                                                    fontWeight: 600,
                                                    fontSize: "14px",
                                                    backgroundColor:
                                                      row.status === "Success"
                                                        ? "#E9FCEB"
                                                        : row.status === "Processing"
                                                          ? "#FFF6E6"
                                                          : row.status === "Withdrawn"
                                                            ? "#EEEEEE"
                                                            : "#FFECEC",
                                                    color:
                                                      row.status === "Success"
                                                        ? "#2E7D32"
                                                        : row.status === "Processing"
                                                          ? "#E89600"
                                                          : row.status === "Withdrawn"
                                                            ? "#000000"
                                                            : "#D32F2F",

                                                    "& .MuiChip-label": {
                                                      padding: 0,
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "flex-start",
                                                      width: "100%",
                                                      px: 2,
                                                    }
                                                  }}
                                                />
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>

                                  {/* Mobile Cards */}
                                  <Box sx={{ display: { xs: "block", md: "none" }, mt: 2 }}>
                                    {paginatedData.map((row, index) => (
                                      <Box
                                        key={index}
                                        sx={{
                                          border: "1px solid #E5E7EB",
                                          borderRadius: 2,
                                          p: 2,
                                          mb: 2,
                                        }}
                                      >
                                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            <TableCell>{formatAction(mapActionLabel(parseAction(row.action)))}</TableCell>
                                          </Typography>
                                          <Chip label={row.status} size="small" color={row.statusColor} />
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 1 }}>
                                          {row.deviceIcon}
                                          {row.device}
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 1 }}>
                                          <PublicIcon sx={{ fontSize: 16 }} />
                                          {row.location}
                                        </Box>

                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                                          {row.date}
                                        </Typography>
                                      </Box>
                                    ))}
                                  </Box>

                                </Box>
                                {/* Pagination activity log privacy page */}
                                <Box sx={{ display: "flex", justifyContent: "center", alignContent: 'center', mb: 2 }}>
                                  <Pagination
                                    count={Math.ceil(activityLog.length / rowsPerPage)}
                                    page={page}
                                    onChange={(e, value) => setPage(value)}
                                    shape="rounded"
                                    sx={{
                                      '& .MuiPaginationItem-root': {
                                        borderRadius: '50%',
                                        '&:hover': {
                                          backgroundColor: '#e3f2fd',
                                        },
                                      },
                                      '& .Mui-selected': {
                                        backgroundColor: '#2563EB !important',
                                        color: '#fff !important',
                                        borderRadius: '50%',
                                        '&:hover': {
                                          backgroundColor: '#2563EB !important',
                                        },
                                      },
                                    }}
                                  />
                                </Box>
                              </>
                            )}

                          </>
                        </Box>

                        {/* Request your data */}
                        <Box
                          sx={{
                            border: '1px solid #E5E7EB',
                            borderRadius: 1,
                            p: '8px 14px !important',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            mb: 1
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                              Request your data
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Download a copy of data we hold — identity verification may be required.
                            </Typography>
                          </Box>

                          {isExportLocked ? (
                            <Tooltip
                              title={`You cannot request data export until ${moment(unlockDate).format("DD MMM YYYY")}`}
                              arrow
                              placement="top"
                            >
                              <Box sx={{ display: "inline-block" }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  disabled
                                  sx={{
                                    mr: 1,
                                    borderRadius: '4px',
                                    px: 4,
                                    borderColor: "#ccc",
                                    color: "#000",
                                    textTransform: "none",
                                    pointerEvents: "auto",
                                    "&:hover": {
                                      borderColor: "#ccc",
                                      backgroundColor: "#eee",
                                    }
                                  }}
                                >
                                  Request Data
                                </Button>
                              </Box>
                            </Tooltip>
                          ) : (
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                mr: 1, borderRadius: '4px',
                                px: 4,
                                borderColor: "#ccc",
                                color: "#000",
                                // backgroundColor: "#fff",
                                textTransform: "none",

                                "&:hover": {
                                  borderColor: "#ccc",
                                  backgroundColor: "#eee",
                                }
                              }}
                              onClick={() => handleOpenDialog("requestData")}
                            >
                              Request Data
                            </Button>
                          )}
                        </Box>
                      </Box>

                      {/* --- ACCOUNT MANAGEMENT --- */}
                      <Box sx={{ border: '1px solid #e5e7eb', p: '10px 14px !important', borderRadius: '6px', mb: 5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>

                          <KeyIcon
                            style={{ width: 22, height: 22 }}
                            stroke="currentColor"
                            strokeWidth={1.8}
                            fill="none"
                          />

                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Account Management
                          </Typography>
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Manage your account and security authentication
                        </Typography>

                        {/* Change Password */}
                        <Box
                          sx={{
                            border: '1px solid #E5E7EB',
                            borderRadius: 1,
                            p: '8px 14px !important',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            mb: 1
                          }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                              Change Your Password
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Keep your account secure by updating your password frequently
                            </Typography>
                          </Box>

                          <Tooltip
                            title={hasPassword ? '' : "You signed up with Google, so there's no password to change."}
                          >
                            <span>
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={!hasPassword}
                                sx={{
                                  mr: 1, borderRadius: '4px',
                                  px: 4,
                                  borderColor: "#ccc",
                                  color: "#000",
                                  // backgroundColor: "#fff",
                                  textTransform: "none",

                                  "&:hover": {
                                    borderColor: "#ccc",
                                    backgroundColor: "#eee",
                                  }
                                }}
                                onClick={() => handleOpenDialog("changePassword")}
                              >
                                Change Password
                              </Button>
                            </span>
                          </Tooltip>
                        </Box>
                      </Box>

                      {/* --- DANGER ZONE --- */}
                      <Box sx={{ border: '1px solid #e5e7eb', p: '10px 14px !important', borderRadius: '6px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '10px 14px 10px 0px !important', }}>
                          {/* <WarningIcon sx={{ fontSize: 20, color: '#E80000' }} /> */}
                          <AlertTriangle style={{ color: '#E80000' }}
                            className="h-6 w-6 text-red-500"
                            strokeWidth={2}
                          />
                          <Typography variant="h6" sx={{ fontWeight: 600, color: '#E80000' }}>
                            Danger Zone
                          </Typography>
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          We will delay permanent account deletion for 30 days to allow recovery.
                        </Typography>

                        <Alert
                          icon={false}
                          severity="error"
                          sx={{
                            background: '#FFE6E6',
                            borderRadius: 1,
                            border: '1px solid #FFB0B0',
                            padding: 0,
                            width: '100%',
                            mb: 2,
                            "& .MuiAlert-message": {
                              padding: 0,
                              width: "100%",
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              flexDirection: { xs: 'column', sm: 'row' },
                              alignItems: { xs: 'flex-start', sm: 'center' },
                              width: '100%',
                              p: '8px 14px !important', gap: 2,
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5, color: '#E80000' }}>
                                Delete Your Account
                              </Typography>
                              <Typography variant="body2">
                                Submit a request to schedule account deletion after 30-day review period.
                              </Typography>
                            </Box>

                            <Tooltip
                              title={
                                isDeletionLocked
                                  ? `You can't request deletion between ${new Date(latestWithdrawDate).toLocaleDateString("en-IN")} to 
                                ${new Date(new Date(latestWithdrawDate).setDate(new Date(latestWithdrawDate).getDate() + 13)
                                  ).toLocaleDateString("en-IN")}`
                                  : ""
                              }
                              placement="top"
                              arrow
                              disableHoverListener={!isDeletionLocked}
                            >
                              <span>
                                <Button
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  disabled={isDeletionLocked}
                                  sx={{ borderRadius: '4px' }}
                                  onClick={() => handleOpenDialog("deleteAccount")}
                                >
                                  {isDeletionLocked
                                    ? "Request Account Deletion"
                                    : "Request Account Deletion"}
                                </Button>
                              </span>
                            </Tooltip>
                          </Box>
                        </Alert>
                      </Box>
                    </Box>
                  )


                )}


                <DialogModal

                  sx={{
                    "& .MuiDialogTitle-root": {
                      display: "none !important",
                    },
                    "& .MuiDialog-paper": {
                      paddingTop: "0px !important",
                    }
                  }}


                  open={dialogOpen}
                  handleClose={handleDialogClose}
                  showCloseIcon={false}
                >

                  <Box sx={{ flex: 1 }}>
                    {dialogType === "requestData" && (
                      <Box sx={{ p: 3 }}>
                        <Typography sx={{ color: "#313131", fontWeight: 900, fontSize: "28px !important", marginBottom: 2 }}>
                          {dialogTitles[dialogType]}
                        </Typography>
                        {/* Description */}
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Download a copy of all your personal data we hold. Identity verification may be required. We’ll send a link via email when ready.
                        </Typography>

                        {/* What you will receive Box */}
                        <Box
                          sx={{
                            border: '1px solid #E5E7EB',
                            borderRadius: 2,
                            padding: '14px !important',
                            mb: 3
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                            What you will receive?
                          </Typography>

                          {/* Profile Information */}
                          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                minWidth: 40,
                                borderRadius: '4px',
                                bgcolor: '#EFF6FF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <UserIcon style={{ color: '#2563EB', width: 22, height: 22 }} />
                            </Box>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.0 }}>
                                Profile Information
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                Name, Email, Phone, Date of Birth, Profile Photo link
                              </Typography>
                            </Box>
                          </Box>

                          {/* <Divider sx={{ my: 1 }} /> */}

                          {/* Activity Logs */}
                          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                minWidth: 40,
                                borderRadius: '4px',
                                bgcolor: '#EFF6FF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <CloudArrowDownIcon style={{ color: '#2563EB', width: 24, height: 24, marginTop: '-3px' }} />
                            </Box>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.0 }}>
                                Activity Logs
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                Login history, Usage Logs, IPs, and Timestamps
                              </Typography>
                            </Box>
                          </Box>

                          {/* <Divider sx={{ my: 1 }} /> */}

                          {/* Preferences and Settings */}
                          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                minWidth: 40,
                                borderRadius: '4px',
                                bgcolor: '#EFF6FF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Settings style={{ color: '#2563EB', width: 20, height: 20, marginTop: '-3px' }} />
                            </Box>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.0 }}>
                                Preferences and Settings
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                Account and Notification preferences, Consent Status, and Modifications History
                              </Typography>
                            </Box>
                          </Box>

                          {/* <Divider sx={{ my: 1 }} /> */}

                          {/* Purchase History */}
                          <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                minWidth: 40,
                                borderRadius: '4px',
                                bgcolor: '#EFF6FF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              {/* <ShoppingCartIcon sx={{ color: '#3B82F6', fontSize: 20 }} /> */}
                              <ShoppingCartOutlinedIcon style={{ color: '#2563EB', width: 22, height: 22 }} />
                            </Box>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.0 }}>
                                Purchase History
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                                Course and Assessment purchases and other payment method updates
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Processing Time Alert */}
                        <Alert severity="warning"
                          icon={<AlertIconView size={20} shiftY={2} style={{ marginTop: 10 }} />}
                          sx={{
                            bgcolor: '#FFF9E6',
                            border: '1px solid #FEF3C7',
                            borderRadius: 2,
                            mb: 3,
                            '& .MuiAlert-icon': {
                              color: '#F59E0B'
                            }
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#92400E', mb: 0.3 }}>
                            Processing Time
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#92400E' }}>
                            Data exports typically take 24 hours to prepare. Large accounts may take longer
                          </Typography>
                        </Alert>

                        {/* Action Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                          <Button
                            variant="outlined"
                            onClick={() => handleDialogClose('requestData')}
                            disabled={loadingRequest}
                            sx={{
                              mb: 1, mr: 1, borderRadius: '4px',
                              px: 4,
                              borderColor: "#CCCCCC",
                              color: "#000",
                              textTransform: "none",

                              "&:hover": {
                                borderColor: "#000",
                                backgroundColor: "rgba(218, 218, 218, 0.08)",
                              }
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleRequestData}
                            disabled={loadingRequest}
                            sx={{
                              mb: 1,
                              borderRadius: '4px',
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                              "&:disabled": {
                                borderColor: "#E0E0E0",
                                color: "#BDBDBD",
                                cursor: "not-allowed",
                              }
                            }}
                          >
                            {loadingRequest ? "Requesting..." : "Request Data"}
                          </Button>

                        </Box>
                      </Box>
                    )}


                    {dialogType === "deleteAccount" && (
                      <Box sx={{ p: 3 }}>
                        <Typography sx={{ color: "#313131", fontWeight: 900, fontSize: "28px !important", marginBottom: 2 }}>
                          {dialogTitles[dialogType]}
                        </Typography>
                        {/* Description */}
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                          Account deletion is permanent after 30 days; during this period, data is only recoverable by you
                        </Typography>

                        <Alert
                          severity="error"
                          icon={<AlertTriangle style={{ color: '#E80000' }}
                            className="h-6 w-6 text-red-500"
                            strokeWidth={2}
                          />

                          }
                          sx={{
                            mb: 3,
                            bgcolor: '#FFEBEE',
                            border: '1px solid #FFCDD2',
                            '& .MuiAlert-icon': {
                              paddingTop: '4px',
                            },
                            '& .MuiAlert-message': {
                              width: '100%',
                              padding: 0
                            }
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 600,
                              color: '#D32F2F',
                              mb: 1
                            }}
                          >
                            What happens when you delete your account?
                          </Typography>

                          <Box component="ul" sx={{ pl: 1, mb: 1, ml: 2, mt: 1, listStyleType: "disc", '& li': { pl: 1, mb: 0.5, }, '& li::marker': { color: '#D32F2F', fontSize: '12px', } }}>
                            <li>
                              <Typography variant="body2" sx={{ color: '#D32F2F' }}>
                                You will lose access to all content and data
                              </Typography>
                            </li>
                            <li>
                              <Typography variant="body2" sx={{ color: '#D32F2F' }}>
                                This cannot be undone after 30 days
                              </Typography>
                            </li>
                            <li>
                              <Typography variant="body2" sx={{ color: '#D32F2F' }}>
                                We may retain some information for legal compliance
                              </Typography>
                            </li>
                            <li>
                              <Typography variant="body2" sx={{ color: '#D32F2F' }}>
                                Active subscriptions will be cancelled
                              </Typography>
                            </li>
                            <li>
                              <Typography variant="body2" sx={{ color: '#D32F2F' }}>
                                You cannot reset your password while account is pending deletion
                              </Typography>
                            </li>
                          </Box>
                        </Alert>

                        {/* Confirmation Input */}
                        <Box sx={{ mb: 3 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600, mb: 1 }}
                          >
                            Type "DELETE" to confirm
                          </Typography>
                          <TextField
                            fullWidth
                            // placeholder="DELETE"
                            variant="outlined"
                            value={deleteConfirmText}
                            onChange={(e) => setDeleteConfirmText(e.target.value)}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#E5E7EB',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#D1D5DB',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3B82F6',
                                },
                              },
                            }}
                          />
                        </Box>

                        {/* Action Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                          <Button
                            variant="outlined"
                            onClick={() => handleDialogClose('deleteAccount')}
                            disabled={loadingRequest}
                            sx={{
                              textTransform: "none",
                              borderRadius: "4px", mr: 1,
                              color: "#000",
                              borderColor: "#ccc !important",
                              "&:hover": {
                                borderColor: "#ccc !important",
                                backgroundColor: "rgba(0,0,0,0.05)",
                              },
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            disabled={deleteConfirmText !== 'DELETE'}
                            onClick={() => handleRequestDeletion(deleteConfirmText)}
                            sx={{
                              textTransform: 'none',
                              bgcolor: '#DC2626',
                              borderRadius: '4px',
                              '&:hover': {
                                bgcolor: '#B91C1C'
                              },
                              '&.Mui-disabled': {
                                bgcolor: '#FCA5A5',
                                color: '#fff'
                              }
                            }}
                          >
                            {loadingRequest ? (
                              <CircularProgress size={20} sx={{ color: "white" }} />
                            ) : (
                              "Request Deletion"
                            )}
                          </Button>
                        </Box>
                      </Box>
                    )}

                    {dialogType === "changePassword" && (
                      <Box sx={{ mb: 2 }}>
                        {/* Description */}
                        <Typography sx={{ color: "#313131", fontWeight: 900, fontSize: "28px !important", marginBottom: 2 }}>
                          {dialogTitles[dialogType]}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0, mb: 2 }}>
                          Enter your current password and choose a new one
                        </Typography>

                        {/* Current Password */}
                        <Box sx={{ mb: 2.5 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                            Current Password
                          </Typography>
                          <TextField
                            fullWidth
                            type={showCurrentPassword ? 'text' : 'password'}
                            value={currentPassword}
                            onChange={(e) => {
                              setCurrentPassword(e.target.value);
                              setOldPasswordError("");
                            }}
                            placeholder="Enter current password"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                    edge="end"
                                  >
                                    {showCurrentPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#E5E7EB',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#D1D5DB',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3B82F6',
                                },
                              },
                            }}
                          />
                          {oldPasswordError && (
                            <FormHelperText error>{oldPasswordError}</FormHelperText>
                          )}
                        </Box>

                        <Box sx={{ mb: 2.5 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                            New Password
                          </Typography>
                          <TextField
                            fullWidth
                            type={showNewPassword ? 'text' : 'password'}
                            value={newPassword}
                            onChange={(e) => {
                              setNewPassword(e.target.value)
                              setNewPasswordError('')
                            }}
                            placeholder="Enter new password"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    edge="end"
                                  >
                                    {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#E5E7EB',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#D1D5DB',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3B82F6',
                                },
                              },
                            }}
                          />
                          {newPasswordError && <FormHelperText error>{newPasswordError}</FormHelperText>}
                        </Box>

                        <Box sx={{ mb: 3 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                            Confirm New Password
                          </Typography>
                          <TextField
                            fullWidth
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                              setConfirmNewPasswordError("");
                            }}
                            placeholder="Re-enter new password"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    edge="end"
                                  >
                                    {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#E5E7EB',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#D1D5DB',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3B82F6',
                                },
                              },
                            }}
                          />
                          {confirmNewPasswordError && (
                            <FormHelperText error>{confirmNewPasswordError}</FormHelperText>   // <-- ADDED
                          )}
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                          <Button
                            variant="outlined"
                            onClick={() => handleDialogClose('changePassword')}
                            sx={{
                              textTransform: "none",
                              borderRadius: "4px", mr: 1,
                              color: "#000",
                              borderColor: "#ccc !important",
                              px: 2.5,
                              lineHeight: 1,
                              "&:hover": {
                                borderColor: "#000 !important",
                                backgroundColor: "rgba(0,0,0,0.05)",
                              },
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleUpdatePassword}
                            sx={{
                              borderRadius: '4px',
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              cursor: "pointer",
                              px: 2.5,
                              "&:hover": { backgroundColor: "#1565c0" }
                            }}
                          >
                            Save Password
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </DialogModal>
                <ResetPasswordModal openModal={openResetModel} closeModel={() => setOpenResetModel(false)} />
                <SnackBar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={snackbar} snackbarTitle={snackbarTitle} snackbarType={snackbarType} close={() => setSnackbar(false)} />
              </Box>
            </Box>
          </Container>
        </>
      }

      {userInfo?.role !== 'USER_DTC' &&
        <>
          <Box id="profileHeaderSection" style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', borderRadius: '10px', padding: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', justifyContent: 'space-between', marginTop: '86px', marginLeft: '20px', marginRight: '20px' }}>
            <Box style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', borderRadius: '10px', padding: '5px', width: '120%', flexGrow: 1 }}>
              <Avatar alt="User Avatar" style={{ marginRight: '10px', backgroundColor: 'black', width: '50px', height: '50px', fontSize: '1.5rem' }}>{initials || '?'}
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', ml: { xs: 0, md: '40px' }, }}>
                  {t("Hi")} {''}{firstName?.charAt(0).toUpperCase() + firstName?.slice(1)} {lastName ? lastName?.charAt(0).toUpperCase() + lastName?.slice(1) : ''}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', ml: { xs: 0, md: '40px' } }}>{t("Welcome to your personalized learning.")}</Typography>
              </Box>
            </Box>
            <Box style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'start', marginRight: '8px' }}>
              <Typography variant="body2" style={{ color: '#00B818', fontWeight: 'bold', marginBottom: '2px' }}>
                {progress < 98 ? t("Complete your profile") : t("Profile Completed")}
              </Typography>

              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  style={{ width: '160px', height: '6px', borderRadius: '5px', marginRight: '4px' }}
                  sx={{ '& .MuiLinearProgress-bar': { backgroundColor: '#00B818' } }} />
                <Typography variant="body2" style={{ color: '#00B818', fontWeight: 'bold' }}>
                  {Math.round(progress)}%
                </Typography>
              </Box>
            </Box>
          </Box>
          <Grid container spacing={2} id="profileContainer" style={{ marginRight: '0px' }}>
            <Grid item xs={12} sm={10} md={3} xl={2.5}>
              <ResponsiveDrawer onDetailChange={handleDetailChange} activeStep={activeStep} />
            </Grid>
            <Grid item xs={12} sm={12} md={9} xl={9.5}>
              <Page style={{ paddingTop: "10px !important" }} title={'Profile'}>
                <Box style={{ marginTop: '0px !important' }}>
                  <Formik initialValues={initial} enableReinitialize >
                    {({ handleChange, values, errors, touched }) => (
                      <Form className={classes.formContainer} >
                        <Grid container  >
                          {activeStep === 0 && (
                            <Grid item xs={12} md={12}>
                              <Typography variant="h5" style={{ color: '#e32f29', fontWeight: 'bold', marginBottom: '16px' }}>{t("Personal info")}</Typography>
                              <Box sx={{ marginLeft: '3%' }}>
                                <Grid container spacing={4} justifyContent="flex-end">
                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>{t("First Name")}</Typography>
                                    <TextField
                                      fullWidth
                                      name="firstName"
                                      placeholder="First Name"
                                      value={values.firstName}
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (error.firstNameError) {
                                          setError(prevError => ({ ...prevError, firstNameError: '' }));
                                        }
                                      }}
                                      onBlur={() => {
                                        if (!values.firstName) {
                                          setError(prevError => ({ ...prevError, firstNameError: 'First name is required' }));
                                        }
                                      }}
                                      error={Boolean(error.firstNameError)}
                                      helperText={t(error.firstNameError)}
                                      InputLabelProps={{
                                        sx: {
                                          marginBottom: '8px',
                                        },
                                      }}
                                    />
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>{t("Last Name")}</Typography>
                                    <TextField
                                      fullWidth
                                      placeholder="Last Name"
                                      name="lastName"
                                      value={values.lastName}
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (error.lastNameError) {
                                          // Clear error when user starts typing
                                          setError(prevError => ({ ...prevError, lastNameError: '' }));
                                        }
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          marginBottom: '8px',
                                        },
                                      }}
                                    />
                                  </Grid>


                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Email")}
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      placeholder='Email'
                                      name="email"
                                      value={values.email}
                                      onChange={handleChange}
                                      error={touched.email && Boolean(errors.email)}
                                      helperText={touched.email && errors.email}
                                      disabled
                                    />
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Phone Number")}
                                    </Typography>
                                    <Box sx={{ width: '100%' }}>
                                      <PhoneNumber
                                        fullWidth
                                        country={'us'}
                                        name="phoneNumber"
                                        specialLabel={''}
                                        value={phone}
                                        onChange={handleChangePhone}
                                      />
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Date of birth")}
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                      <DatePicker fullWidth
                                        // label="Select Date"
                                        value={selectedDate}
                                        maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                        onChange={handleDateChange}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="MM/DD/YYYY"
                                            inputProps={{
                                              ...params.inputProps,
                                              readOnly: true,
                                            }}
                                            fullWidth
                                            sx={{
                                              'input::placeholder': {
                                                textTransform: 'uppercase',
                                              },
                                              '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                  borderColor: 'black',
                                                },
                                                '&:hover fieldset': {
                                                  borderColor: 'black',
                                                },
                                                '&.Mui-focused fieldset': {
                                                  borderColor: 'black',
                                                },
                                              },
                                            }}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                      <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                        {t("Gender")}
                                      </Typography>
                                      <Select
                                        name="gender"
                                        displayEmpty
                                        value={values.gender}
                                        onChange={handleChange}
                                        error={touched.gender && Boolean(errors.gender)}
                                      >
                                        {genderDetails && genderDetails?.length > 0 && genderDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </Grid>

                                <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '20px' }}>
                                  <Grid item>
                                    <Button onClick={() => handleSaveOld(values, phone, selectedDate, userData)} variant="contained" color="primary" type="submit">
                                      {t("Save and Continue")}
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                          )}


                          {activeStep === 1 && (
                            <Grid item xs={12} md={12}>
                              <Typography
                                variant="h5"
                                style={{ color: '#e32f29', fontWeight: 'bold', marginBottom: '20px' }}
                              >
                                {t("Professional Info")}
                              </Typography>
                              <Box sx={{ marginLeft: '3%' }}>
                                <Grid container spacing={4}>
                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Education")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="education"
                                        value={values.education || ""}
                                        onChange={handleChange}
                                        error={touched.education && Boolean(errors.education)}
                                        displayEmpty
                                      >

                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Education")}
                                        </MenuItem>
                                        {educationDetails && educationDetails?.length > 0 && educationDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}

                                      </Select>
                                      <FormHelperText>{touched.education && errors.education}</FormHelperText>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Job")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="job"
                                        value={values.job || ""}
                                        onChange={handleChange}
                                        error={touched.job && Boolean(errors.job)}
                                        displayEmpty
                                      >
                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Job")}
                                        </MenuItem>
                                        {jobDetails && jobDetails?.length > 0 && jobDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}
                                      </Select>
                                      <FormHelperText>{touched.job && errors.job}</FormHelperText>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Current Role")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="currentRole"
                                        value={values.currentRole || ""}
                                        onChange={handleChange}
                                        error={touched.currentRole && Boolean(errors.currentRole)}
                                        displayEmpty
                                      >
                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Current Role")}
                                        </MenuItem>
                                        {roleDetails && roleDetails?.length > 0 && roleDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}

                                      </Select>
                                      <FormHelperText>{touched.currentRole && errors.currentRole}</FormHelperText>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Work Experience")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="workExperience"
                                        value={values.workExperience || ""}
                                        onChange={handleChange}
                                        error={touched.workExperience && Boolean(errors.workExperience)}
                                        displayEmpty
                                      >
                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Work Experience")}
                                        </MenuItem>
                                        {workDetails && workDetails?.length > 0 && workDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>

                                        ))}

                                      </Select>
                                      <FormHelperText>{touched.workExperience && errors.workExperience}</FormHelperText>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("Career Goals")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="careerGoal"
                                        value={values.careerGoal || ""}
                                        onChange={handleChange}
                                        error={touched.careerGoal && Boolean(errors.careerGoal)}
                                        displayEmpty
                                      >
                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Career Goals")}
                                        </MenuItem>
                                        {carrierDetails && carrierDetails?.length > 0 && carrierDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}
                                      </Select>
                                      <FormHelperText>{touched.careerGoal && errors.careerGoal}</FormHelperText>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" component="div" className={classes.typoFontWeight} gutterBottom>
                                      {t("How Did You Hear About Us?")} </Typography>
                                    <FormControl fullWidth>
                                      <Select
                                        name="referral"
                                        value={values.referral || ""}
                                        onChange={handleChange}
                                        error={touched.referral && Boolean(errors.referral)}
                                        displayEmpty
                                      >
                                        <MenuItem value="" disabled style={{ fontStyle: "normal" }}>
                                          {t("Referral Source")}
                                        </MenuItem>
                                        {aboutDetails && aboutDetails?.length > 0 && aboutDetails.map((data) => (
                                          <MenuItem key={data.value} value={data.value}>{data.value}</MenuItem>
                                        ))}
                                      </Select>
                                      <FormHelperText>{touched.referral && errors.referral}</FormHelperText>
                                    </FormControl>
                                  </Grid>



                                </Grid>
                                <Grid container spacing={2} style={{ marginTop: '20px' }} alignItems="center" justifyContent="flex-end">
                                  <Grid item>
                                    <Button onClick={() => handleBack()} variant="outlined" className={classes.backbutton}>
                                      {t("Back")}
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button onClick={() => handleSave(values, phone, selectedDate)} variant="contained" color="primary" type="submit" style={{ marginLeft: '20px' }}>
                                      {t("Save and Continue")}
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                          )}
                          {activeStep === 2 &&
                            <Grid item xs={12} md={12}>
                              <Typography variant="h5" style={{ color: '#e32f29', fontWeight: 'b' }}>{t("Other Details")}</Typography>

                              <Box sx={{ marginLeft: '2%', marginTop: '30px' }}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                  }}
                                >
                                  {uniqueTagCodes.map((tagCode, index) => {
                                    const tag = categoryDetails.find(t => (typeof t === 'object' ? t.description : t) === tagCode);


                                    return (
                                      <Box
                                        key={index}
                                        className={`${classes.card} ${selectedTags.includes(tagCode) ? classes.selected : ''}`}
                                        onClick={() => handleTagClick(tagCode)}
                                      >
                                        <Typography className={classes.tagText}>
                                          {typeof tag === 'string' ? (
                                            <>
                                              {tag.length > 12 ? (
                                                <Tooltip title={tag}>
                                                  <span>{tag.slice(0, 12)}...</span>
                                                </Tooltip>
                                              ) : (
                                                tag
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {tag.description && tag.description.length > 12 ? (
                                                <Tooltip title={tag.description}>
                                                  <span>{tag.description.slice(0, 12)}...</span>
                                                </Tooltip>
                                              ) : (
                                                tag.description
                                              )}
                                            </>
                                          )}
                                        </Typography>

                                      </Box>
                                    );
                                  })}

                                  <Box
                                    key="others"
                                    className={classes.card}
                                    onClick={() => handleTagClick('Others')}
                                  >
                                    <Typography className={classes.tagText} >
                                      {t("Others +")}
                                    </Typography>
                                  </Box>
                                </Box>
                                {showOthersInput && (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, margin: 2 }}>
                                    <TextField
                                      variant="outlined"
                                      value={newTag}
                                      onChange={(e) => setNewTag(e.target.value)}
                                      placeholder="Enter your interest"
                                    />
                                    <IconButton onClick={handleCancel} color="orange">
                                      <CloseIcon />
                                    </IconButton>
                                    <Button onClick={handlePushDetails} variant="contained">
                                      {t("Submit")}
                                    </Button>

                                  </Box>
                                )}
                                <Grid container spacing={2} style={{ marginTop: '20px' }} alignItems="center" justifyContent="flex-end">
                                  <Grid item>
                                    <Button onClick={() => handleBack()} variant="outlined" className={classes.backbutton}>
                                      {t("Back")}
                                    </Button>
                                  </Grid>

                                  <Grid item>
                                    <Button onClick={() => handleUpdateDetails(values,selectedDate)} variant="contained" color="primary" type="submit" style={{ marginLeft: '20px' }}>
                                      {UpdateLoading ? <CircularProgress size={24} color="inherit" /> : t("Save and Continue")}
                                    </Button>
                                  </Grid>

                                </Grid>
                              </Box>
                            </Grid>
                          }
                        </Grid>
                      </Form>
                    )}
                  </Formik>

                </Box>
                <SnackBar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} autoHideDuration={5000} open={snackbar} snackbarTitle={snackbarTitle} close={() => setSnackbar(false)} />
                <ResetPasswordModal openModal={openResetModel} closeModel={() => setOpenResetModel(false)} />
                <SnackBar anchorOrigin={{ vertical: 'top', horizontal: 'left' }} open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
              </Page>
            </Grid>
          </Grid>
        </>
      }
      <div className="w-full mt-auto px-4 sm:px-6 md:px-8 lg:px-12">
        <Footer />
      </div>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    display: 'flex',
  },
  logo: {
    border: '1px solid lightgrey',
    borderRadius: '10px',
    marginRight: '3rem',
    padding: '1rem',
  },

  name: {
    fontSize: '14px',
    color: '#0C0A09',
    fontWeight: '600',
  },

  changePassword: {
    color: '#FE7000',
    letterSpacing: '0px;',
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'start',
    },
  },
  backgroundStyle: {
    boxShadow: '0px 3px 30px #0000000A;',
    border: '1px solid #ECECEC',
    borderRadius: '10px;',
    background: '#FFFFFF',
    padding: '1rem',
  },

  btnStyle: {
    color: '#FE7000;',
    fontSize: '1rem',
    fontWeight: '600',
    outline: '1px solid #FE7000',
  },

  fontSizeiconname: {
    letterSpacing: '0.43px;',
    color: '#6D6969;',
    marginLeft: '1rem;',
    fontSize: '0.8rem',
  },
  contanerBackground: {
    backgroundColor: '#FAFAFA',
    height: '100vh',
  },

  typoFontWeight: {
    fontSize: '1rem;',
    fontWeight: '400',
  },
  typoFontWeightone: {
    fontSize: '1rem;',
  },
  input: {
    display: 'none',
  },
  imgPreviewRoot: {
    borderRadius: '10px',
    padding: '0.8rem;',
    marginBottom: 16,
  },
  badgeAlign: {
    boxShadow: '0 2px 8px -5px #ff0000',
    color: '#FF0000',
    fontSize: '1.2rem',
    backgroundColor: '#fff',
    padding: '2px',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  fileImgSIze: {
    width: '100%',
    height: '120px',
    objectFit: 'cover',
    objectPosition: 'center',
    border: '1px solid #fff',
    borderRadius: '5px',
    boxShadow: '0 3px 10px rgb(0 0 0 / 20%)',
  },
  formContainer: {
    padding: '20px',
    // border: '1px solid #E0E0E0',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
  stepIndicator: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 0',
  },
  step: {
    border: '2px solid #ccc',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    fontSize: '18px',
    color: '#333',
  },
  activeStep: {
    borderColor: '#1976D2',
    backgroundColor: '#1976D2',
    color: '#fff',
  },
  stepLabel: {
    textAlign: 'center',
    margin: 0,
    fontWeight: 600,
    fontSize: '14px',
    color: '#333',
  },
  formTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  skipButton: {
    borderColor: '#1976D2',
    color: '#1976D2',
  },
  card: {
    borderRadius: '10px',
    height: '30px',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'flex-start',
    paddingLeft: '20px',
    paddingRight: '20px',
    padding: '8px',
    textAlign: 'left',
    margin: '10px',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    width: '150px',
    // height: '35px'
  },
  tagText: {

    color: 'black',
    fontSize: '12px',
    fontWeight: 'bolder',

  },
  selected: {
    backgroundColor: '#ffb36b',
    color: 'white',
  },
  createButton: {
    borderRadius: '5px',
    marginTop: '20px',
    background: "#D52F37",
    fontSize: "12px",
    width: "200px"
  },
  '@global': {
    '.react-tel-input .country-list .country': {
      display: 'flex!important',
      alignContent: 'center',
      gap: '10px',
      padding: '8px 12px',
    },
    '.react-tel-input .country-list .country-name': {
      marginLeft: '30px!important'
    }
  }

}));

export default Account;
